var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _rect411, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _rect426, _rect427, _rect428, _rect429, _rect430, _rect431, _rect432, _rect433, _rect434, _rect435, _rect436, _rect437, _rect438, _rect439, _rect440, _rect441, _rect442, _rect443, _rect444, _rect445, _rect446, _rect447, _rect448, _rect449, _rect450, _rect451, _rect452, _rect453, _rect454, _rect455, _rect456, _rect457, _rect458, _rect459, _rect460, _rect461, _rect462, _rect463, _rect464, _rect465, _rect466, _rect467, _rect468, _rect469, _rect470, _rect471, _rect472, _rect473, _rect474, _rect475, _rect476, _rect477, _rect478, _rect479, _rect480, _rect481, _rect482, _rect483, _rect484, _rect485, _rect486, _rect487, _rect488, _rect489, _rect490, _rect491, _rect492, _rect493, _rect494, _rect495, _rect496, _rect497, _rect498, _rect499, _rect500, _rect501, _rect502, _rect503, _rect504, _rect505, _rect506, _rect507, _rect508, _rect509, _rect510, _rect511, _rect512, _rect513, _rect514, _rect515, _rect516, _rect517, _rect518, _rect519, _rect520, _rect521, _rect522, _rect523, _rect524, _rect525, _rect526, _rect527, _rect528, _rect529, _rect530, _rect531, _rect532, _rect533, _rect534, _rect535, _rect536, _rect537, _rect538, _rect539, _rect540, _rect541, _rect542, _rect543, _rect544, _rect545, _rect546, _rect547, _rect548, _rect549, _rect550, _rect551, _rect552, _rect553, _rect554, _rect555, _rect556, _rect557, _rect558, _rect559, _rect560, _rect561, _rect562, _rect563, _rect564, _rect565, _rect566, _rect567, _rect568, _rect569, _rect570, _rect571, _rect572, _rect573, _rect574, _rect575, _rect576, _rect577, _rect578, _rect579, _rect580, _rect581, _rect582, _rect583, _rect584, _rect585, _rect586, _rect587, _rect588, _rect589, _rect590, _rect591, _rect592, _rect593, _rect594, _rect595, _rect596, _rect597, _rect598, _rect599, _rect600, _rect601, _rect602, _rect603, _rect604, _rect605, _rect606, _rect607, _rect608, _rect609, _rect610, _rect611, _rect612, _rect613, _rect614, _rect615, _rect616, _rect617, _rect618, _rect619, _rect620, _rect621, _rect622, _rect623, _rect624, _rect625, _rect626, _rect627, _rect628, _rect629, _rect630, _rect631, _rect632, _rect633, _rect634, _rect635, _rect636, _rect637, _rect638, _rect639, _rect640, _rect641, _rect642, _rect643, _rect644, _rect645, _rect646, _rect647, _rect648, _rect649, _rect650, _rect651, _rect652, _rect653, _rect654, _rect655, _rect656, _rect657, _rect658, _rect659, _rect660, _rect661, _rect662, _rect663, _rect664, _rect665, _rect666, _rect667, _rect668, _rect669, _rect670, _rect671, _rect672, _rect673, _rect674, _rect675, _rect676, _rect677, _rect678, _rect679, _rect680, _rect681, _rect682, _rect683, _rect684, _rect685, _rect686, _rect687, _rect688, _rect689, _rect690, _rect691, _rect692, _rect693, _rect694, _rect695, _rect696, _rect697, _rect698, _rect699, _rect700, _rect701, _rect702, _rect703, _rect704, _rect705, _rect706, _rect707, _rect708, _rect709, _rect710, _rect711, _rect712, _rect713, _rect714, _rect715, _rect716, _rect717, _rect718, _rect719, _rect720, _rect721, _rect722, _rect723, _rect724, _rect725, _rect726, _rect727, _rect728, _rect729, _rect730, _rect731, _rect732, _rect733, _rect734, _rect735, _rect736, _rect737, _rect738, _rect739, _rect740, _rect741, _rect742, _rect743, _rect744, _rect745, _rect746, _rect747, _rect748, _rect749, _rect750, _rect751, _rect752, _rect753, _rect754, _rect755, _rect756, _rect757, _rect758, _rect759, _rect760, _rect761, _rect762, _rect763, _rect764, _rect765, _rect766, _rect767, _rect768, _rect769, _rect770, _rect771, _rect772, _rect773, _rect774, _rect775, _rect776, _rect777, _rect778, _rect779, _rect780, _rect781, _rect782, _rect783, _rect784, _rect785, _rect786, _rect787, _rect788, _rect789, _rect790, _rect791, _rect792, _rect793, _rect794, _rect795, _rect796, _rect797, _rect798, _rect799, _rect800, _rect801, _rect802, _rect803, _rect804, _rect805, _rect806, _rect807, _rect808, _rect809, _rect810, _rect811, _rect812, _rect813, _rect814, _rect815, _rect816, _rect817, _rect818, _rect819, _rect820, _rect821, _rect822, _rect823, _rect824, _rect825, _rect826, _rect827, _rect828, _rect829, _rect830, _rect831, _rect832, _rect833, _rect834, _rect835, _rect836, _rect837, _rect838, _rect839, _rect840, _rect841, _rect842, _rect843, _rect844, _rect845, _rect846, _rect847, _rect848, _rect849, _rect850, _rect851, _rect852, _rect853, _rect854, _rect855, _rect856, _rect857, _rect858, _rect859, _rect860, _rect861, _rect862, _rect863, _rect864, _rect865, _rect866, _rect867, _rect868, _rect869, _rect870, _rect871, _rect872, _rect873, _rect874, _rect875, _rect876, _rect877, _rect878, _rect879, _rect880, _rect881, _rect882, _rect883, _rect884, _rect885, _rect886, _rect887, _rect888, _rect889, _rect890, _rect891, _rect892, _rect893, _rect894, _rect895, _rect896, _rect897, _rect898, _rect899, _rect900, _rect901, _rect902, _rect903, _rect904, _rect905, _rect906, _rect907, _rect908, _rect909, _rect910, _rect911, _rect912, _rect913, _rect914, _rect915, _rect916, _rect917, _rect918, _rect919, _rect920, _rect921, _rect922, _rect923, _rect924, _rect925, _rect926, _rect927, _rect928, _rect929, _rect930, _rect931, _rect932, _rect933, _rect934, _rect935, _rect936, _rect937, _rect938, _rect939, _rect940, _rect941, _rect942, _rect943, _rect944, _rect945, _rect946, _rect947, _rect948, _rect949, _rect950, _rect951, _rect952, _rect953, _rect954, _rect955, _rect956, _rect957, _rect958, _rect959, _rect960, _rect961, _rect962, _rect963, _rect964, _rect965, _rect966, _rect967, _rect968, _rect969, _rect970, _rect971, _rect972, _rect973, _rect974, _rect975, _rect976, _rect977, _rect978, _rect979, _rect980, _rect981, _rect982, _rect983, _rect984, _rect985, _rect986, _rect987, _rect988, _rect989, _rect990, _rect991, _rect992, _rect993, _rect994, _rect995, _rect996, _rect997, _rect998, _rect999, _rect1000, _rect1001, _rect1002, _rect1003, _rect1004, _rect1005, _rect1006, _rect1007, _rect1008, _rect1009, _rect1010, _rect1011, _rect1012, _rect1013, _rect1014, _rect1015, _rect1016, _rect1017, _rect1018, _rect1019, _rect1020, _rect1021, _rect1022, _rect1023, _rect1024, _rect1025, _rect1026, _rect1027, _rect1028, _rect1029, _rect1030, _rect1031, _rect1032, _rect1033, _rect1034, _rect1035, _rect1036, _rect1037, _rect1038, _rect1039, _rect1040, _rect1041, _rect1042, _rect1043, _rect1044, _rect1045, _rect1046, _rect1047, _rect1048, _rect1049, _rect1050, _rect1051, _rect1052, _rect1053, _rect1054, _rect1055, _rect1056, _rect1057, _rect1058, _rect1059, _rect1060, _rect1061, _rect1062, _rect1063, _rect1064, _rect1065, _rect1066, _rect1067, _rect1068, _rect1069, _rect1070, _rect1071, _rect1072, _rect1073, _rect1074, _rect1075, _rect1076, _rect1077, _rect1078, _rect1079, _rect1080, _rect1081, _rect1082, _rect1083, _rect1084, _rect1085, _rect1086, _rect1087, _rect1088, _rect1089, _rect1090, _rect1091, _rect1092, _rect1093, _rect1094, _rect1095, _rect1096, _rect1097, _rect1098, _rect1099, _rect1100, _rect1101, _rect1102, _rect1103, _rect1104, _rect1105, _rect1106, _rect1107, _rect1108, _rect1109, _rect1110, _rect1111, _rect1112, _rect1113, _rect1114, _rect1115, _rect1116, _rect1117, _rect1118, _rect1119, _rect1120, _rect1121, _rect1122, _rect1123, _rect1124, _rect1125, _rect1126, _rect1127, _rect1128, _rect1129, _rect1130, _rect1131, _rect1132, _rect1133, _rect1134, _rect1135, _rect1136, _rect1137, _rect1138, _rect1139, _rect1140, _rect1141, _rect1142, _rect1143, _rect1144, _rect1145, _rect1146, _rect1147, _rect1148, _rect1149, _rect1150, _rect1151, _rect1152, _rect1153, _rect1154, _rect1155, _rect1156, _rect1157, _rect1158, _rect1159, _rect1160, _rect1161, _rect1162, _rect1163, _rect1164, _rect1165, _rect1166, _rect1167, _rect1168, _rect1169, _rect1170, _rect1171, _rect1172, _rect1173, _rect1174, _rect1175, _rect1176, _rect1177, _rect1178, _rect1179, _rect1180, _rect1181, _rect1182, _rect1183, _rect1184, _rect1185, _rect1186, _rect1187, _rect1188, _rect1189, _rect1190, _rect1191, _rect1192, _rect1193, _rect1194, _rect1195, _rect1196, _rect1197, _rect1198, _rect1199, _rect1200, _rect1201, _rect1202, _rect1203, _rect1204, _rect1205, _rect1206, _rect1207, _rect1208, _rect1209, _rect1210, _rect1211, _rect1212, _rect1213, _rect1214, _rect1215, _rect1216, _rect1217, _rect1218, _rect1219, _rect1220, _rect1221, _rect1222, _rect1223, _rect1224, _rect1225, _rect1226, _rect1227, _rect1228, _rect1229, _rect1230, _rect1231, _rect1232, _rect1233, _rect1234, _rect1235, _rect1236, _rect1237, _rect1238, _rect1239, _rect1240, _rect1241, _rect1242, _rect1243, _rect1244, _rect1245, _rect1246, _rect1247, _rect1248, _rect1249, _rect1250, _rect1251, _rect1252, _rect1253, _rect1254, _rect1255, _rect1256, _rect1257, _rect1258, _rect1259, _rect1260, _rect1261, _rect1262, _rect1263, _rect1264, _rect1265, _rect1266, _rect1267, _rect1268, _rect1269, _rect1270, _rect1271, _rect1272, _rect1273, _rect1274, _rect1275, _rect1276, _rect1277, _rect1278, _rect1279, _rect1280, _rect1281, _rect1282, _rect1283, _rect1284, _rect1285, _rect1286, _rect1287, _rect1288, _rect1289, _rect1290, _rect1291, _rect1292, _rect1293, _rect1294, _rect1295, _rect1296, _rect1297, _rect1298, _rect1299, _rect1300, _rect1301, _rect1302, _rect1303, _rect1304, _rect1305, _rect1306, _rect1307, _rect1308, _rect1309, _rect1310, _rect1311, _rect1312, _rect1313, _rect1314, _rect1315, _rect1316, _rect1317, _rect1318, _rect1319, _rect1320, _rect1321, _rect1322, _rect1323, _rect1324, _rect1325, _rect1326, _rect1327, _rect1328, _rect1329, _rect1330, _rect1331, _rect1332, _rect1333, _rect1334, _rect1335, _rect1336, _rect1337, _rect1338, _rect1339, _rect1340, _rect1341, _rect1342, _rect1343, _rect1344, _rect1345, _rect1346, _rect1347, _rect1348, _rect1349, _rect1350, _rect1351, _rect1352, _rect1353, _rect1354, _rect1355, _rect1356, _rect1357, _rect1358, _rect1359, _rect1360, _rect1361, _rect1362, _rect1363, _rect1364, _rect1365, _rect1366, _rect1367, _rect1368, _rect1369, _rect1370, _rect1371, _rect1372, _rect1373, _rect1374, _rect1375, _rect1376, _rect1377, _rect1378, _rect1379, _rect1380, _rect1381, _rect1382, _rect1383, _rect1384, _rect1385, _rect1386, _rect1387, _rect1388, _rect1389, _rect1390, _rect1391, _rect1392, _rect1393, _rect1394, _rect1395, _rect1396, _rect1397, _rect1398, _rect1399, _rect1400, _rect1401, _rect1402, _rect1403, _rect1404, _rect1405, _rect1406, _rect1407, _rect1408, _rect1409, _rect1410, _rect1411, _rect1412, _rect1413, _rect1414, _rect1415, _rect1416, _rect1417, _rect1418, _rect1419, _rect1420, _rect1421, _rect1422, _rect1423, _rect1424, _rect1425, _rect1426, _rect1427, _rect1428, _rect1429, _rect1430, _rect1431, _rect1432, _rect1433, _rect1434, _rect1435, _rect1436, _rect1437, _rect1438, _rect1439, _rect1440, _rect1441, _rect1442, _rect1443, _rect1444, _rect1445, _rect1446, _rect1447, _rect1448, _rect1449, _rect1450, _rect1451, _rect1452, _rect1453, _rect1454, _rect1455, _rect1456, _rect1457, _rect1458, _rect1459, _rect1460, _rect1461, _rect1462, _rect1463, _rect1464, _rect1465, _rect1466, _rect1467, _rect1468, _rect1469, _rect1470, _rect1471, _rect1472, _rect1473, _rect1474, _rect1475, _rect1476, _rect1477, _rect1478, _rect1479, _rect1480, _rect1481, _rect1482, _rect1483, _rect1484, _rect1485, _rect1486, _rect1487, _rect1488, _rect1489, _rect1490, _rect1491, _rect1492, _rect1493, _rect1494, _rect1495, _rect1496, _rect1497, _rect1498, _rect1499, _rect1500, _rect1501, _rect1502, _rect1503, _rect1504, _rect1505, _rect1506, _rect1507, _rect1508, _rect1509, _rect1510, _rect1511, _rect1512, _rect1513, _rect1514, _rect1515, _rect1516, _rect1517, _rect1518, _rect1519, _rect1520, _rect1521, _rect1522, _rect1523, _rect1524, _rect1525, _rect1526, _rect1527, _rect1528, _rect1529, _rect1530, _rect1531, _rect1532, _rect1533, _rect1534, _rect1535, _rect1536, _rect1537, _rect1538, _rect1539, _rect1540, _rect1541, _rect1542, _rect1543, _rect1544, _rect1545, _rect1546, _rect1547, _rect1548, _rect1549, _rect1550, _rect1551, _rect1552, _rect1553, _rect1554, _rect1555, _rect1556, _rect1557, _rect1558, _rect1559, _rect1560, _rect1561, _rect1562, _rect1563, _rect1564, _rect1565, _rect1566, _rect1567, _rect1568, _rect1569, _rect1570, _rect1571, _rect1572, _rect1573, _rect1574, _rect1575, _rect1576, _rect1577, _rect1578, _rect1579, _rect1580, _rect1581, _rect1582, _rect1583, _rect1584, _rect1585, _rect1586, _rect1587, _rect1588, _rect1589, _rect1590, _rect1591, _rect1592, _rect1593, _rect1594, _rect1595, _rect1596, _rect1597, _rect1598, _rect1599, _rect1600, _rect1601, _rect1602, _rect1603, _rect1604, _rect1605, _rect1606, _rect1607, _rect1608, _rect1609, _rect1610, _rect1611, _rect1612, _rect1613, _rect1614, _rect1615, _rect1616, _rect1617, _rect1618, _rect1619, _rect1620, _rect1621, _rect1622, _rect1623, _rect1624, _rect1625, _rect1626, _rect1627, _rect1628, _rect1629, _rect1630, _rect1631, _rect1632, _rect1633, _rect1634, _rect1635, _rect1636, _rect1637, _rect1638, _rect1639, _rect1640, _rect1641, _rect1642, _rect1643, _rect1644, _rect1645, _rect1646, _rect1647, _rect1648, _rect1649, _rect1650, _rect1651, _rect1652, _rect1653, _rect1654, _rect1655, _rect1656, _rect1657, _rect1658, _rect1659, _rect1660, _rect1661, _rect1662, _rect1663, _rect1664, _rect1665, _rect1666, _rect1667, _rect1668, _rect1669, _rect1670, _rect1671, _rect1672, _rect1673, _rect1674, _rect1675, _rect1676, _rect1677, _rect1678, _rect1679, _rect1680, _rect1681, _rect1682, _rect1683, _rect1684, _rect1685, _rect1686, _rect1687, _rect1688, _rect1689, _rect1690, _rect1691, _rect1692, _rect1693, _rect1694, _rect1695, _rect1696, _rect1697, _rect1698, _rect1699, _rect1700, _rect1701, _rect1702, _rect1703, _rect1704, _rect1705, _rect1706, _rect1707, _rect1708, _rect1709, _rect1710, _rect1711, _rect1712, _rect1713, _rect1714, _rect1715, _rect1716, _rect1717, _rect1718, _rect1719, _rect1720, _rect1721, _rect1722, _rect1723, _rect1724, _rect1725, _rect1726, _rect1727, _rect1728, _rect1729, _rect1730, _rect1731, _rect1732, _rect1733, _rect1734, _rect1735, _rect1736, _rect1737, _rect1738, _rect1739, _rect1740, _rect1741, _rect1742, _rect1743, _rect1744, _rect1745, _rect1746, _rect1747, _rect1748, _rect1749, _rect1750, _rect1751, _rect1752, _rect1753, _rect1754, _rect1755, _rect1756, _rect1757, _rect1758, _rect1759, _rect1760, _rect1761, _rect1762, _rect1763, _rect1764, _rect1765, _rect1766, _rect1767, _rect1768, _rect1769, _rect1770, _rect1771, _rect1772, _rect1773, _rect1774, _rect1775, _rect1776, _rect1777, _rect1778, _rect1779, _rect1780, _rect1781, _rect1782, _rect1783, _rect1784, _rect1785, _rect1786, _rect1787, _rect1788, _rect1789, _rect1790, _rect1791, _rect1792, _rect1793, _rect1794, _rect1795, _rect1796, _rect1797, _rect1798, _rect1799, _rect1800, _rect1801, _rect1802, _rect1803, _rect1804, _rect1805, _rect1806, _rect1807, _rect1808, _rect1809, _rect1810, _rect1811, _rect1812, _rect1813, _rect1814, _rect1815, _rect1816, _rect1817, _rect1818, _rect1819, _rect1820, _rect1821, _rect1822, _rect1823, _rect1824, _rect1825, _rect1826, _rect1827, _rect1828, _rect1829, _rect1830, _rect1831, _rect1832, _rect1833, _rect1834, _rect1835, _rect1836, _rect1837, _rect1838, _rect1839, _rect1840, _rect1841, _rect1842, _rect1843, _rect1844, _rect1845, _rect1846, _rect1847, _rect1848, _rect1849, _rect1850, _rect1851, _rect1852, _rect1853, _rect1854, _rect1855, _rect1856, _rect1857, _rect1858, _rect1859, _rect1860, _rect1861, _rect1862, _rect1863, _rect1864, _rect1865, _rect1866, _rect1867, _rect1868, _rect1869, _rect1870, _rect1871, _rect1872, _rect1873, _rect1874, _rect1875, _rect1876, _rect1877, _rect1878, _rect1879, _rect1880, _rect1881, _rect1882, _rect1883, _rect1884, _rect1885, _rect1886, _rect1887, _rect1888, _rect1889, _rect1890, _rect1891, _rect1892, _rect1893, _rect1894, _rect1895, _rect1896, _rect1897, _rect1898, _rect1899, _rect1900, _rect1901, _rect1902, _rect1903, _rect1904, _rect1905, _rect1906, _rect1907, _rect1908, _rect1909, _rect1910, _rect1911, _rect1912, _rect1913, _rect1914, _rect1915, _rect1916, _rect1917, _rect1918, _rect1919, _rect1920, _rect1921, _rect1922, _rect1923, _rect1924, _rect1925, _rect1926, _rect1927, _rect1928, _rect1929, _rect1930, _rect1931, _rect1932, _rect1933, _rect1934, _rect1935, _rect1936, _rect1937, _rect1938, _rect1939, _rect1940, _rect1941, _rect1942, _rect1943, _rect1944, _rect1945, _rect1946, _rect1947, _rect1948, _rect1949, _rect1950, _rect1951, _rect1952, _rect1953, _rect1954, _rect1955, _rect1956, _rect1957, _rect1958, _rect1959, _rect1960, _rect1961, _rect1962, _rect1963, _rect1964, _rect1965, _rect1966, _rect1967, _rect1968, _rect1969, _rect1970, _rect1971, _rect1972, _rect1973, _rect1974, _rect1975, _rect1976, _rect1977, _rect1978, _rect1979, _rect1980, _rect1981, _rect1982, _rect1983, _rect1984, _rect1985, _rect1986, _rect1987, _rect1988, _rect1989, _rect1990, _rect1991, _rect1992, _rect1993, _rect1994, _rect1995, _rect1996, _rect1997, _rect1998, _rect1999, _rect2000, _rect2001, _rect2002, _rect2003, _rect2004, _rect2005, _rect2006, _rect2007, _rect2008, _rect2009, _rect2010, _rect2011, _rect2012, _rect2013, _rect2014, _rect2015, _rect2016, _rect2017, _rect2018, _rect2019, _rect2020, _rect2021, _rect2022, _rect2023, _rect2024, _rect2025, _rect2026, _rect2027, _rect2028, _rect2029, _rect2030, _rect2031, _rect2032, _rect2033, _rect2034, _rect2035, _rect2036, _rect2037, _rect2038, _rect2039, _rect2040, _rect2041, _rect2042, _rect2043, _rect2044, _rect2045, _rect2046, _rect2047, _rect2048, _rect2049, _rect2050, _rect2051, _rect2052, _rect2053, _rect2054, _rect2055, _rect2056, _rect2057, _rect2058, _rect2059, _rect2060, _rect2061, _rect2062, _rect2063, _rect2064, _rect2065, _rect2066, _rect2067, _rect2068, _rect2069, _rect2070, _rect2071, _rect2072, _rect2073, _rect2074, _rect2075, _rect2076, _rect2077, _rect2078, _rect2079, _rect2080, _rect2081, _rect2082, _rect2083, _rect2084, _rect2085, _rect2086, _rect2087, _rect2088, _rect2089, _rect2090, _rect2091, _rect2092, _rect2093, _rect2094, _rect2095, _rect2096, _rect2097, _rect2098, _rect2099, _rect2100, _rect2101, _rect2102, _rect2103, _rect2104, _rect2105, _rect2106, _rect2107, _rect2108, _rect2109, _rect2110, _rect2111, _rect2112, _rect2113, _rect2114, _rect2115, _rect2116, _rect2117, _rect2118, _rect2119, _rect2120, _rect2121, _rect2122, _rect2123, _rect2124, _rect2125, _rect2126, _rect2127, _rect2128, _rect2129, _rect2130, _rect2131, _rect2132, _rect2133, _rect2134, _rect2135, _rect2136, _rect2137, _rect2138, _rect2139, _rect2140, _rect2141, _rect2142, _rect2143, _rect2144, _rect2145, _rect2146, _rect2147, _rect2148, _rect2149, _rect2150, _rect2151, _rect2152, _rect2153, _rect2154, _rect2155, _rect2156, _rect2157, _rect2158, _rect2159, _rect2160, _rect2161, _rect2162, _rect2163, _rect2164, _rect2165, _rect2166, _rect2167, _rect2168, _rect2169, _rect2170, _rect2171, _rect2172, _rect2173, _rect2174, _rect2175, _rect2176, _rect2177, _rect2178, _rect2179, _rect2180, _rect2181, _rect2182, _rect2183, _rect2184, _rect2185, _rect2186, _rect2187, _rect2188, _rect2189, _rect2190, _rect2191, _rect2192, _rect2193, _rect2194, _rect2195, _rect2196, _rect2197, _rect2198, _rect2199, _rect2200, _rect2201, _rect2202, _rect2203, _rect2204, _rect2205, _rect2206, _rect2207, _rect2208, _rect2209, _rect2210, _rect2211, _rect2212, _rect2213, _rect2214, _rect2215, _rect2216, _rect2217, _rect2218, _rect2219, _rect2220, _rect2221, _rect2222, _rect2223, _rect2224, _rect2225, _rect2226, _rect2227, _rect2228, _rect2229, _rect2230, _rect2231, _rect2232, _rect2233, _rect2234, _rect2235, _rect2236, _rect2237, _rect2238, _rect2239, _rect2240, _rect2241, _rect2242, _rect2243, _rect2244, _rect2245, _rect2246, _rect2247, _rect2248, _rect2249, _rect2250, _rect2251, _rect2252, _rect2253, _rect2254, _rect2255, _rect2256, _rect2257, _rect2258, _rect2259, _rect2260, _rect2261, _rect2262, _rect2263, _rect2264, _rect2265, _rect2266, _rect2267, _rect2268, _rect2269, _rect2270, _rect2271, _rect2272, _rect2273, _rect2274, _rect2275, _rect2276, _rect2277, _rect2278, _rect2279, _rect2280, _rect2281, _rect2282, _rect2283, _rect2284, _rect2285, _rect2286, _rect2287, _rect2288, _rect2289, _rect2290, _rect2291, _rect2292, _rect2293, _rect2294, _rect2295, _rect2296, _rect2297, _rect2298, _rect2299, _rect2300, _rect2301, _rect2302, _rect2303, _rect2304, _rect2305, _rect2306, _rect2307, _rect2308, _rect2309, _rect2310, _rect2311, _rect2312, _rect2313, _rect2314, _rect2315, _rect2316, _rect2317, _rect2318, _rect2319, _rect2320, _rect2321, _rect2322, _rect2323, _rect2324, _rect2325, _rect2326, _rect2327, _rect2328, _rect2329, _rect2330, _rect2331, _rect2332, _rect2333, _rect2334, _rect2335, _rect2336, _rect2337, _rect2338, _rect2339, _rect2340, _rect2341, _rect2342, _rect2343, _rect2344, _rect2345, _rect2346, _rect2347, _rect2348, _rect2349, _rect2350, _rect2351, _rect2352, _rect2353, _rect2354, _rect2355, _rect2356, _rect2357, _rect2358, _rect2359, _rect2360, _rect2361, _rect2362, _rect2363, _rect2364, _rect2365, _rect2366, _rect2367, _rect2368, _rect2369, _rect2370, _rect2371, _rect2372, _rect2373, _rect2374, _rect2375, _rect2376, _rect2377, _rect2378, _rect2379, _rect2380, _rect2381, _rect2382, _rect2383, _rect2384, _rect2385, _rect2386, _rect2387, _rect2388, _rect2389, _rect2390, _rect2391, _rect2392, _rect2393, _rect2394, _rect2395, _rect2396, _rect2397, _rect2398, _rect2399, _rect2400, _rect2401, _rect2402, _rect2403, _rect2404, _rect2405, _rect2406, _rect2407, _rect2408, _rect2409, _rect2410, _rect2411, _rect2412, _rect2413, _rect2414, _rect2415, _rect2416, _rect2417, _rect2418, _rect2419, _rect2420, _rect2421, _rect2422, _rect2423, _rect2424, _rect2425, _rect2426, _rect2427, _rect2428, _rect2429, _rect2430, _rect2431, _rect2432, _rect2433, _rect2434, _rect2435, _rect2436, _rect2437, _rect2438, _rect2439, _rect2440, _rect2441, _rect2442, _rect2443, _rect2444, _rect2445, _rect2446, _rect2447, _rect2448, _rect2449, _rect2450, _rect2451, _rect2452, _rect2453, _rect2454, _rect2455, _rect2456, _rect2457, _rect2458, _rect2459, _rect2460, _rect2461, _rect2462, _rect2463, _rect2464, _rect2465, _rect2466, _rect2467, _rect2468, _rect2469, _rect2470, _rect2471, _rect2472, _rect2473, _rect2474, _rect2475, _rect2476, _rect2477, _rect2478, _rect2479, _rect2480, _rect2481, _rect2482, _rect2483, _rect2484, _rect2485, _rect2486, _rect2487, _rect2488, _rect2489, _rect2490, _rect2491, _rect2492, _rect2493, _rect2494, _rect2495, _rect2496, _rect2497, _rect2498, _rect2499, _rect2500, _rect2501, _rect2502, _rect2503, _rect2504, _rect2505, _rect2506, _rect2507, _rect2508, _rect2509, _rect2510, _rect2511, _rect2512, _rect2513, _rect2514, _rect2515, _rect2516, _rect2517, _rect2518, _rect2519, _rect2520, _rect2521, _rect2522, _rect2523, _rect2524, _rect2525, _rect2526, _rect2527, _rect2528, _rect2529, _rect2530, _rect2531, _rect2532, _rect2533, _rect2534, _rect2535, _rect2536, _rect2537, _rect2538, _rect2539, _rect2540, _rect2541, _rect2542, _rect2543, _rect2544, _rect2545, _rect2546, _rect2547, _rect2548, _rect2549, _rect2550, _rect2551, _rect2552, _rect2553, _rect2554, _rect2555, _rect2556, _rect2557, _rect2558, _rect2559, _rect2560, _rect2561, _rect2562, _rect2563, _rect2564, _rect2565, _rect2566, _rect2567, _rect2568, _rect2569, _rect2570, _rect2571, _rect2572, _rect2573, _rect2574, _rect2575, _rect2576, _rect2577, _rect2578, _rect2579, _rect2580, _rect2581, _rect2582, _rect2583, _rect2584, _rect2585, _rect2586, _rect2587, _rect2588, _rect2589, _rect2590, _rect2591, _rect2592, _rect2593, _rect2594, _rect2595, _rect2596, _rect2597, _rect2598, _rect2599, _rect2600, _rect2601, _rect2602, _rect2603, _rect2604, _rect2605, _rect2606, _rect2607, _rect2608, _rect2609, _rect2610, _rect2611, _rect2612, _rect2613, _rect2614, _rect2615, _rect2616, _rect2617, _rect2618, _rect2619, _rect2620, _rect2621, _rect2622, _rect2623, _rect2624, _rect2625, _rect2626, _rect2627, _rect2628, _rect2629, _rect2630, _rect2631, _rect2632, _rect2633, _rect2634, _rect2635, _rect2636, _rect2637;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJewel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 0,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 1,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 2,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 2,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 2,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 2,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 2,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 2,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 2,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 3,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 3,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 3,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 3,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 3,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 3,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 3,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 4,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFF9"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFF9"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFF9"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFFFF9"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 4,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 4,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 4,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 4,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 5,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 5,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 5,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 5,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 5,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 5,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 5,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 6,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 6,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 6,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 6,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 6,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 6,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 7,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 7,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 7,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 7,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 7,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 7,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 7,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 7,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 7,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 7,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 7,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 7,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 7,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 7,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 7,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 7,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 7,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 7,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 7,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 7,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 7,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 7,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 7,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 7,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 7,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 7,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 8,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 8,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 8,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 8,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 8,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 8,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 9,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 9,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 9,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 9,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 9,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 9,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 9,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 9,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 9,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 9,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 9,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 9,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 9,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 9,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 9,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 9,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 9,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 9,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 9,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 9,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 9,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 9,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 10,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 10,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 10,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 10,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 10,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 10,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 10,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 10,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 10,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 10,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 10,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 10,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 10,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 10,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 10,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 10,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 10,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 10,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 10,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 10,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 11,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 11,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 11,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 11,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 11,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 11,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 11,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 11,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 11,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 11,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 11,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 11,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 11,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 11,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 11,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 11,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 11,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 11,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 11,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 11,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 11,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 11,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 11,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 11,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 11,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 12,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 12,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 12,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 12,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 12,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 12,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 12,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 12,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 12,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 12,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 12,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 12,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 12,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 12,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 12,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 12,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 12,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 12,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 12,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 12,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect446 || (_rect446 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect447 || (_rect447 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect448 || (_rect448 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect449 || (_rect449 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect450 || (_rect450 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect451 || (_rect451 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect452 || (_rect452 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect453 || (_rect453 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 12,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect454 || (_rect454 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 12,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect455 || (_rect455 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 12,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect456 || (_rect456 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect457 || (_rect457 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 13,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect458 || (_rect458 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 13,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect459 || (_rect459 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect460 || (_rect460 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect461 || (_rect461 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect462 || (_rect462 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect463 || (_rect463 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect464 || (_rect464 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect465 || (_rect465 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect466 || (_rect466 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect467 || (_rect467 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 13,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect468 || (_rect468 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect469 || (_rect469 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect470 || (_rect470 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 13,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect471 || (_rect471 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 13,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect472 || (_rect472 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 13,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect473 || (_rect473 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 13,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect474 || (_rect474 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect475 || (_rect475 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 13,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect476 || (_rect476 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 13,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect477 || (_rect477 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 13,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect478 || (_rect478 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 13,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect479 || (_rect479 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 13,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect480 || (_rect480 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 13,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect481 || (_rect481 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 13,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect482 || (_rect482 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 13,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect483 || (_rect483 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 13,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect484 || (_rect484 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 13,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect485 || (_rect485 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 13,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect486 || (_rect486 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect487 || (_rect487 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 13,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect488 || (_rect488 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 13,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect489 || (_rect489 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 13,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect490 || (_rect490 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 13,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect491 || (_rect491 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 13,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect492 || (_rect492 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect493 || (_rect493 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 13,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect494 || (_rect494 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect495 || (_rect495 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect496 || (_rect496 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect497 || (_rect497 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect498 || (_rect498 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect499 || (_rect499 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect500 || (_rect500 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect501 || (_rect501 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect502 || (_rect502 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 13,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect503 || (_rect503 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 13,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect504 || (_rect504 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 13,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect505 || (_rect505 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect506 || (_rect506 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect507 || (_rect507 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 14,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect508 || (_rect508 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect509 || (_rect509 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect510 || (_rect510 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect511 || (_rect511 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect512 || (_rect512 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect513 || (_rect513 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect514 || (_rect514 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect515 || (_rect515 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect516 || (_rect516 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect517 || (_rect517 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect518 || (_rect518 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect519 || (_rect519 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 14,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect520 || (_rect520 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 14,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect521 || (_rect521 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 14,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect522 || (_rect522 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 14,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect523 || (_rect523 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 14,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect524 || (_rect524 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 14,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect525 || (_rect525 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect526 || (_rect526 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 14,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect527 || (_rect527 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 14,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect528 || (_rect528 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 14,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect529 || (_rect529 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 14,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect530 || (_rect530 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 14,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect531 || (_rect531 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 14,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect532 || (_rect532 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 14,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect533 || (_rect533 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 14,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect534 || (_rect534 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 14,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect535 || (_rect535 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect536 || (_rect536 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 14,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect537 || (_rect537 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 14,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect538 || (_rect538 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 14,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect539 || (_rect539 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 14,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect540 || (_rect540 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 14,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect541 || (_rect541 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 14,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect542 || (_rect542 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect543 || (_rect543 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect544 || (_rect544 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 14,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect545 || (_rect545 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect546 || (_rect546 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect547 || (_rect547 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect548 || (_rect548 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect549 || (_rect549 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect550 || (_rect550 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect551 || (_rect551 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect552 || (_rect552 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect553 || (_rect553 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 14,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect554 || (_rect554 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 14,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect555 || (_rect555 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 14,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect556 || (_rect556 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 15,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect557 || (_rect557 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 15,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect558 || (_rect558 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 15,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect559 || (_rect559 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect560 || (_rect560 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect561 || (_rect561 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect562 || (_rect562 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect563 || (_rect563 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect564 || (_rect564 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect565 || (_rect565 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 15,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect566 || (_rect566 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 15,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect567 || (_rect567 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 15,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect568 || (_rect568 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect569 || (_rect569 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect570 || (_rect570 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect571 || (_rect571 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect572 || (_rect572 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 15,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect573 || (_rect573 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 15,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect574 || (_rect574 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 15,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect575 || (_rect575 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 15,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect576 || (_rect576 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 15,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect577 || (_rect577 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect578 || (_rect578 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 15,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect579 || (_rect579 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 15,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect580 || (_rect580 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 15,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect581 || (_rect581 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 15,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect582 || (_rect582 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 15,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect583 || (_rect583 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 15,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect584 || (_rect584 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 15,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect585 || (_rect585 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 15,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect586 || (_rect586 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 15,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect587 || (_rect587 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect588 || (_rect588 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 15,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect589 || (_rect589 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 15,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect590 || (_rect590 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 15,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect591 || (_rect591 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 15,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect592 || (_rect592 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 15,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect593 || (_rect593 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect594 || (_rect594 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect595 || (_rect595 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect596 || (_rect596 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect597 || (_rect597 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 15,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect598 || (_rect598 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 15,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect599 || (_rect599 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 15,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect600 || (_rect600 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect601 || (_rect601 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect602 || (_rect602 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect603 || (_rect603 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect604 || (_rect604 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect605 || (_rect605 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 15,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect606 || (_rect606 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 15,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect607 || (_rect607 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 15,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect608 || (_rect608 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 15,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect609 || (_rect609 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 16,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect610 || (_rect610 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 16,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect611 || (_rect611 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 16,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect612 || (_rect612 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect613 || (_rect613 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect614 || (_rect614 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect615 || (_rect615 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect616 || (_rect616 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect617 || (_rect617 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect618 || (_rect618 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 16,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect619 || (_rect619 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect620 || (_rect620 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect621 || (_rect621 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect622 || (_rect622 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect623 || (_rect623 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect624 || (_rect624 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect625 || (_rect625 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect626 || (_rect626 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 16,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect627 || (_rect627 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 16,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect628 || (_rect628 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect629 || (_rect629 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 16,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect630 || (_rect630 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 16,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect631 || (_rect631 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 16,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect632 || (_rect632 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 16,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect633 || (_rect633 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 16,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect634 || (_rect634 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 16,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect635 || (_rect635 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 16,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect636 || (_rect636 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 16,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect637 || (_rect637 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 16,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect638 || (_rect638 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 16,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect639 || (_rect639 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 16,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect640 || (_rect640 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 16,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect641 || (_rect641 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 16,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect642 || (_rect642 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 16,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect643 || (_rect643 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 16,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect644 || (_rect644 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 16,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect645 || (_rect645 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 16,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect646 || (_rect646 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 16,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect647 || (_rect647 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect648 || (_rect648 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 16,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect649 || (_rect649 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect650 || (_rect650 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect651 || (_rect651 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect652 || (_rect652 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect653 || (_rect653 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect654 || (_rect654 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 16,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect655 || (_rect655 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect656 || (_rect656 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect657 || (_rect657 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect658 || (_rect658 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect659 || (_rect659 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect660 || (_rect660 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 16,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect661 || (_rect661 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 16,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect662 || (_rect662 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 16,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect663 || (_rect663 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 16,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect664 || (_rect664 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 17,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect665 || (_rect665 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 17,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect666 || (_rect666 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 17,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect667 || (_rect667 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect668 || (_rect668 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect669 || (_rect669 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect670 || (_rect670 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect671 || (_rect671 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect672 || (_rect672 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect673 || (_rect673 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 17,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect674 || (_rect674 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect675 || (_rect675 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect676 || (_rect676 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 17,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect677 || (_rect677 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 17,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect678 || (_rect678 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 17,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect679 || (_rect679 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect680 || (_rect680 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect681 || (_rect681 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect682 || (_rect682 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect683 || (_rect683 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 17,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect684 || (_rect684 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 17,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect685 || (_rect685 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 17,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect686 || (_rect686 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 17,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect687 || (_rect687 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 17,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect688 || (_rect688 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFFFF9"
  })), _rect689 || (_rect689 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect690 || (_rect690 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 17,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect691 || (_rect691 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 17,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect692 || (_rect692 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 17,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect693 || (_rect693 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 17,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect694 || (_rect694 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 17,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect695 || (_rect695 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 17,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect696 || (_rect696 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFFFF9"
  })), _rect697 || (_rect697 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 17,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect698 || (_rect698 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 17,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect699 || (_rect699 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 17,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect700 || (_rect700 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 17,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect701 || (_rect701 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 17,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect702 || (_rect702 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect703 || (_rect703 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect704 || (_rect704 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect705 || (_rect705 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect706 || (_rect706 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 17,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect707 || (_rect707 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 17,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect708 || (_rect708 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 17,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect709 || (_rect709 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect710 || (_rect710 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect711 || (_rect711 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 17,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect712 || (_rect712 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect713 || (_rect713 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect714 || (_rect714 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect715 || (_rect715 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect716 || (_rect716 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect717 || (_rect717 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 17,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect718 || (_rect718 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 17,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect719 || (_rect719 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 17,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect720 || (_rect720 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 17,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect721 || (_rect721 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 18,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect722 || (_rect722 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 18,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect723 || (_rect723 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect724 || (_rect724 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect725 || (_rect725 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect726 || (_rect726 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect727 || (_rect727 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect728 || (_rect728 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect729 || (_rect729 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 18,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect730 || (_rect730 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect731 || (_rect731 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect732 || (_rect732 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 18,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect733 || (_rect733 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect734 || (_rect734 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 18,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect735 || (_rect735 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 18,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect736 || (_rect736 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect737 || (_rect737 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 18,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect738 || (_rect738 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect739 || (_rect739 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect740 || (_rect740 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 18,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect741 || (_rect741 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect742 || (_rect742 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 18,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect743 || (_rect743 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 18,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect744 || (_rect744 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 18,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect745 || (_rect745 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFFF9"
  })), _rect746 || (_rect746 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect747 || (_rect747 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect748 || (_rect748 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect749 || (_rect749 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect750 || (_rect750 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect751 || (_rect751 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect752 || (_rect752 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect753 || (_rect753 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFFF9"
  })), _rect754 || (_rect754 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 18,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect755 || (_rect755 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 18,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect756 || (_rect756 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 18,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect757 || (_rect757 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 18,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect758 || (_rect758 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 18,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect759 || (_rect759 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect760 || (_rect760 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect761 || (_rect761 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 18,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect762 || (_rect762 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 18,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect763 || (_rect763 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 18,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect764 || (_rect764 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 18,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect765 || (_rect765 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 18,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect766 || (_rect766 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 18,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect767 || (_rect767 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect768 || (_rect768 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect769 || (_rect769 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 18,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect770 || (_rect770 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect771 || (_rect771 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect772 || (_rect772 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect773 || (_rect773 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect774 || (_rect774 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect775 || (_rect775 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 18,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect776 || (_rect776 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 18,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect777 || (_rect777 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 18,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect778 || (_rect778 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 19,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect779 || (_rect779 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 19,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect780 || (_rect780 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect781 || (_rect781 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect782 || (_rect782 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FFFFF9"
  })), _rect783 || (_rect783 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect784 || (_rect784 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect785 || (_rect785 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 19,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect786 || (_rect786 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect787 || (_rect787 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect788 || (_rect788 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 19,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect789 || (_rect789 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 19,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect790 || (_rect790 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 19,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect791 || (_rect791 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 19,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect792 || (_rect792 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 19,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect793 || (_rect793 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 19,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect794 || (_rect794 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 19,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect795 || (_rect795 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 19,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect796 || (_rect796 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 19,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect797 || (_rect797 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 1,
    height: 1,
    fill: "#CDF884"
  })), _rect798 || (_rect798 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 19,
    width: 1,
    height: 1,
    fill: "#CDF884"
  })), _rect799 || (_rect799 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 19,
    width: 1,
    height: 1,
    fill: "#CDF884"
  })), _rect800 || (_rect800 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 19,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect801 || (_rect801 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect802 || (_rect802 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 19,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect803 || (_rect803 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 19,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect804 || (_rect804 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 19,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect805 || (_rect805 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 19,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect806 || (_rect806 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 19,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect807 || (_rect807 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 19,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect808 || (_rect808 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 19,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect809 || (_rect809 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 19,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect810 || (_rect810 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 19,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect811 || (_rect811 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect812 || (_rect812 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 19,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect813 || (_rect813 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 19,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect814 || (_rect814 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 19,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect815 || (_rect815 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 19,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect816 || (_rect816 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 19,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect817 || (_rect817 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 19,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect818 || (_rect818 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 19,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect819 || (_rect819 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 19,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect820 || (_rect820 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 19,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect821 || (_rect821 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 19,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect822 || (_rect822 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 19,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect823 || (_rect823 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 19,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect824 || (_rect824 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 19,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect825 || (_rect825 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect826 || (_rect826 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect827 || (_rect827 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 19,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect828 || (_rect828 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect829 || (_rect829 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect830 || (_rect830 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect831 || (_rect831 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect832 || (_rect832 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 19,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect833 || (_rect833 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 19,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect834 || (_rect834 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 19,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect835 || (_rect835 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect836 || (_rect836 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 20,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect837 || (_rect837 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 20,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect838 || (_rect838 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 20,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect839 || (_rect839 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 20,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect840 || (_rect840 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 20,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect841 || (_rect841 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 20,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect842 || (_rect842 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect843 || (_rect843 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect844 || (_rect844 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 20,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect845 || (_rect845 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect846 || (_rect846 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect847 || (_rect847 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect848 || (_rect848 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect849 || (_rect849 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect850 || (_rect850 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect851 || (_rect851 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect852 || (_rect852 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect853 || (_rect853 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect854 || (_rect854 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 20,
    width: 1,
    height: 1,
    fill: "#CDF884"
  })), _rect855 || (_rect855 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 1,
    height: 1,
    fill: "#CDF884"
  })), _rect856 || (_rect856 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 20,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect857 || (_rect857 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 20,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect858 || (_rect858 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect859 || (_rect859 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect860 || (_rect860 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect861 || (_rect861 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect862 || (_rect862 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect863 || (_rect863 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect864 || (_rect864 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect865 || (_rect865 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect866 || (_rect866 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect867 || (_rect867 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect868 || (_rect868 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect869 || (_rect869 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 20,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect870 || (_rect870 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 20,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect871 || (_rect871 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 20,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect872 || (_rect872 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 20,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect873 || (_rect873 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 20,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect874 || (_rect874 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 20,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect875 || (_rect875 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect876 || (_rect876 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 20,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect877 || (_rect877 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 20,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect878 || (_rect878 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 20,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect879 || (_rect879 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 20,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect880 || (_rect880 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 20,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect881 || (_rect881 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 20,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect882 || (_rect882 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 20,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect883 || (_rect883 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect884 || (_rect884 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 20,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect885 || (_rect885 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 20,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect886 || (_rect886 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 20,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect887 || (_rect887 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 20,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect888 || (_rect888 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 20,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect889 || (_rect889 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 20,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect890 || (_rect890 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 20,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect891 || (_rect891 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 20,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect892 || (_rect892 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect893 || (_rect893 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 21,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect894 || (_rect894 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect895 || (_rect895 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect896 || (_rect896 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect897 || (_rect897 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect898 || (_rect898 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect899 || (_rect899 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect900 || (_rect900 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect901 || (_rect901 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 21,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect902 || (_rect902 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect903 || (_rect903 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect904 || (_rect904 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect905 || (_rect905 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect906 || (_rect906 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect907 || (_rect907 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect908 || (_rect908 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect909 || (_rect909 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect910 || (_rect910 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 21,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect911 || (_rect911 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 21,
    width: 1,
    height: 1,
    fill: "#CDF884"
  })), _rect912 || (_rect912 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 21,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect913 || (_rect913 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect914 || (_rect914 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect915 || (_rect915 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect916 || (_rect916 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect917 || (_rect917 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect918 || (_rect918 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect919 || (_rect919 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect920 || (_rect920 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect921 || (_rect921 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect922 || (_rect922 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect923 || (_rect923 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect924 || (_rect924 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect925 || (_rect925 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect926 || (_rect926 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect927 || (_rect927 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect928 || (_rect928 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 21,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect929 || (_rect929 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 21,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect930 || (_rect930 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 21,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect931 || (_rect931 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 21,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect932 || (_rect932 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 21,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect933 || (_rect933 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 21,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect934 || (_rect934 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 21,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect935 || (_rect935 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 21,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect936 || (_rect936 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 21,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect937 || (_rect937 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 21,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect938 || (_rect938 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 21,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect939 || (_rect939 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 21,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect940 || (_rect940 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect941 || (_rect941 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 21,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect942 || (_rect942 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect943 || (_rect943 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect944 || (_rect944 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect945 || (_rect945 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 21,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect946 || (_rect946 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 21,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect947 || (_rect947 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 21,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect948 || (_rect948 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 21,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect949 || (_rect949 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect950 || (_rect950 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 22,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect951 || (_rect951 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect952 || (_rect952 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect953 || (_rect953 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect954 || (_rect954 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect955 || (_rect955 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect956 || (_rect956 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect957 || (_rect957 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect958 || (_rect958 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 22,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect959 || (_rect959 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 22,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect960 || (_rect960 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 22,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect961 || (_rect961 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect962 || (_rect962 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect963 || (_rect963 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect964 || (_rect964 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect965 || (_rect965 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect966 || (_rect966 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect967 || (_rect967 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 22,
    width: 1,
    height: 1,
    fill: "#CDF884"
  })), _rect968 || (_rect968 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 22,
    width: 1,
    height: 1,
    fill: "#CDF884"
  })), _rect969 || (_rect969 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect970 || (_rect970 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect971 || (_rect971 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect972 || (_rect972 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect973 || (_rect973 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect974 || (_rect974 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect975 || (_rect975 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect976 || (_rect976 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect977 || (_rect977 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect978 || (_rect978 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect979 || (_rect979 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect980 || (_rect980 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect981 || (_rect981 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect982 || (_rect982 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect983 || (_rect983 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect984 || (_rect984 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 22,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect985 || (_rect985 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect986 || (_rect986 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 22,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect987 || (_rect987 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 22,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect988 || (_rect988 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 22,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect989 || (_rect989 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 22,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect990 || (_rect990 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 22,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect991 || (_rect991 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 22,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect992 || (_rect992 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 22,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect993 || (_rect993 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 22,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect994 || (_rect994 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 22,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect995 || (_rect995 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 22,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect996 || (_rect996 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 22,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect997 || (_rect997 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect998 || (_rect998 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 22,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect999 || (_rect999 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1000 || (_rect1000 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1001 || (_rect1001 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1002 || (_rect1002 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 22,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1003 || (_rect1003 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 22,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1004 || (_rect1004 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 22,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1005 || (_rect1005 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 22,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1006 || (_rect1006 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 23,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1007 || (_rect1007 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 23,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1008 || (_rect1008 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1009 || (_rect1009 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1010 || (_rect1010 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1011 || (_rect1011 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1012 || (_rect1012 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1013 || (_rect1013 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 23,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect1014 || (_rect1014 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1015 || (_rect1015 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 23,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1016 || (_rect1016 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 23,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1017 || (_rect1017 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 23,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1018 || (_rect1018 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 23,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1019 || (_rect1019 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 23,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1020 || (_rect1020 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1021 || (_rect1021 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1022 || (_rect1022 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 23,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1023 || (_rect1023 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 23,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1024 || (_rect1024 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 23,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1025 || (_rect1025 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1026 || (_rect1026 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 23,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1027 || (_rect1027 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 23,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1028 || (_rect1028 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 23,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1029 || (_rect1029 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 23,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1030 || (_rect1030 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 23,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1031 || (_rect1031 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 23,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1032 || (_rect1032 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 23,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1033 || (_rect1033 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 23,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1034 || (_rect1034 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 23,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1035 || (_rect1035 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 23,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1036 || (_rect1036 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 23,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1037 || (_rect1037 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 23,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1038 || (_rect1038 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 23,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1039 || (_rect1039 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1040 || (_rect1040 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1041 || (_rect1041 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 23,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1042 || (_rect1042 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 23,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1043 || (_rect1043 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1044 || (_rect1044 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 23,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1045 || (_rect1045 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 23,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1046 || (_rect1046 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 23,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1047 || (_rect1047 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 23,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1048 || (_rect1048 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 23,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1049 || (_rect1049 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 23,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1050 || (_rect1050 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 23,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1051 || (_rect1051 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 23,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1052 || (_rect1052 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 23,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1053 || (_rect1053 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 23,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1054 || (_rect1054 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1055 || (_rect1055 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 23,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1056 || (_rect1056 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1057 || (_rect1057 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1058 || (_rect1058 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 23,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1059 || (_rect1059 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 23,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1060 || (_rect1060 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 23,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1061 || (_rect1061 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 23,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1062 || (_rect1062 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 23,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1063 || (_rect1063 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 24,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1064 || (_rect1064 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 24,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1065 || (_rect1065 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 24,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1066 || (_rect1066 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 24,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1067 || (_rect1067 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 24,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1068 || (_rect1068 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 24,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1069 || (_rect1069 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 24,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1070 || (_rect1070 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 24,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect1071 || (_rect1071 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 24,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1072 || (_rect1072 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 24,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1073 || (_rect1073 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 24,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1074 || (_rect1074 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 24,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1075 || (_rect1075 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 24,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1076 || (_rect1076 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 24,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1077 || (_rect1077 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 24,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1078 || (_rect1078 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 24,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1079 || (_rect1079 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 24,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1080 || (_rect1080 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 24,
    width: 1,
    height: 1,
    fill: "#FFFFF9"
  })), _rect1081 || (_rect1081 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 24,
    width: 1,
    height: 1,
    fill: "#FFFFF9"
  })), _rect1082 || (_rect1082 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 24,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1083 || (_rect1083 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 24,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1084 || (_rect1084 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 24,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1085 || (_rect1085 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 24,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1086 || (_rect1086 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 24,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1087 || (_rect1087 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1088 || (_rect1088 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 24,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1089 || (_rect1089 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 24,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1090 || (_rect1090 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 24,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1091 || (_rect1091 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1092 || (_rect1092 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 24,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1093 || (_rect1093 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 24,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1094 || (_rect1094 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 24,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1095 || (_rect1095 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1096 || (_rect1096 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1097 || (_rect1097 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 24,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1098 || (_rect1098 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 24,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1099 || (_rect1099 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 24,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1100 || (_rect1100 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1101 || (_rect1101 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 24,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1102 || (_rect1102 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 24,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1103 || (_rect1103 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 24,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1104 || (_rect1104 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 24,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1105 || (_rect1105 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 24,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1106 || (_rect1106 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 24,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1107 || (_rect1107 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 24,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1108 || (_rect1108 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 24,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1109 || (_rect1109 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 24,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1110 || (_rect1110 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1111 || (_rect1111 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 24,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1112 || (_rect1112 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 24,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1113 || (_rect1113 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 24,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1114 || (_rect1114 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 24,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1115 || (_rect1115 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 24,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1116 || (_rect1116 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 24,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1117 || (_rect1117 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 24,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1118 || (_rect1118 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 24,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1119 || (_rect1119 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 24,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1120 || (_rect1120 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 25,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1121 || (_rect1121 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 25,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1122 || (_rect1122 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 25,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1123 || (_rect1123 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 25,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1124 || (_rect1124 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 25,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1125 || (_rect1125 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 25,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1126 || (_rect1126 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 25,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1127 || (_rect1127 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 25,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect1128 || (_rect1128 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 25,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1129 || (_rect1129 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 25,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1130 || (_rect1130 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 25,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1131 || (_rect1131 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 25,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1132 || (_rect1132 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 25,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1133 || (_rect1133 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 25,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1134 || (_rect1134 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 25,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1135 || (_rect1135 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 25,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1136 || (_rect1136 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 25,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1137 || (_rect1137 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 25,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1138 || (_rect1138 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 25,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1139 || (_rect1139 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 25,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1140 || (_rect1140 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 25,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1141 || (_rect1141 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 25,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1142 || (_rect1142 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 25,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1143 || (_rect1143 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 25,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1144 || (_rect1144 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 25,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1145 || (_rect1145 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1146 || (_rect1146 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 25,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1147 || (_rect1147 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 25,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1148 || (_rect1148 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 25,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1149 || (_rect1149 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 25,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1150 || (_rect1150 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 25,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1151 || (_rect1151 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1152 || (_rect1152 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1153 || (_rect1153 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 25,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1154 || (_rect1154 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 25,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1155 || (_rect1155 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 25,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1156 || (_rect1156 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1157 || (_rect1157 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1158 || (_rect1158 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 25,
    width: 1,
    height: 1,
    fill: "#CDF884"
  })), _rect1159 || (_rect1159 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 25,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1160 || (_rect1160 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 25,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1161 || (_rect1161 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 25,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1162 || (_rect1162 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 25,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1163 || (_rect1163 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 25,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1164 || (_rect1164 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 25,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1165 || (_rect1165 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 25,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1166 || (_rect1166 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 25,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1167 || (_rect1167 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 25,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1168 || (_rect1168 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 25,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1169 || (_rect1169 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 25,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1170 || (_rect1170 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 25,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1171 || (_rect1171 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 25,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1172 || (_rect1172 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 25,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1173 || (_rect1173 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 25,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1174 || (_rect1174 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 25,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1175 || (_rect1175 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 25,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1176 || (_rect1176 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 25,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1177 || (_rect1177 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 26,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1178 || (_rect1178 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 26,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1179 || (_rect1179 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 26,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1180 || (_rect1180 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 26,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1181 || (_rect1181 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 26,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1182 || (_rect1182 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 26,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1183 || (_rect1183 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 26,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1184 || (_rect1184 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 26,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect1185 || (_rect1185 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 26,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1186 || (_rect1186 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 26,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1187 || (_rect1187 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 26,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1188 || (_rect1188 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 26,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1189 || (_rect1189 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 26,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1190 || (_rect1190 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 26,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1191 || (_rect1191 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 26,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1192 || (_rect1192 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 26,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1193 || (_rect1193 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 26,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1194 || (_rect1194 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 26,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1195 || (_rect1195 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 26,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1196 || (_rect1196 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 26,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1197 || (_rect1197 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 26,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1198 || (_rect1198 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 26,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1199 || (_rect1199 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 26,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1200 || (_rect1200 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 26,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1201 || (_rect1201 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 26,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1202 || (_rect1202 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 26,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1203 || (_rect1203 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1204 || (_rect1204 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 26,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1205 || (_rect1205 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 26,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1206 || (_rect1206 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 26,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1207 || (_rect1207 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1208 || (_rect1208 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1209 || (_rect1209 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 26,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1210 || (_rect1210 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 26,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1211 || (_rect1211 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 26,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1212 || (_rect1212 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1213 || (_rect1213 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1214 || (_rect1214 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1215 || (_rect1215 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 26,
    width: 1,
    height: 1,
    fill: "#CDF884"
  })), _rect1216 || (_rect1216 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 26,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1217 || (_rect1217 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 26,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1218 || (_rect1218 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 26,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1219 || (_rect1219 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 26,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1220 || (_rect1220 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 26,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1221 || (_rect1221 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 26,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1222 || (_rect1222 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 26,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1223 || (_rect1223 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 26,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1224 || (_rect1224 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 26,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1225 || (_rect1225 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 26,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1226 || (_rect1226 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 26,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1227 || (_rect1227 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 26,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1228 || (_rect1228 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 26,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1229 || (_rect1229 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 26,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1230 || (_rect1230 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 26,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1231 || (_rect1231 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 26,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1232 || (_rect1232 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 26,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1233 || (_rect1233 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 26,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1234 || (_rect1234 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 27,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1235 || (_rect1235 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 27,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1236 || (_rect1236 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 27,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1237 || (_rect1237 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 27,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1238 || (_rect1238 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 27,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1239 || (_rect1239 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 27,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1240 || (_rect1240 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 27,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1241 || (_rect1241 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 27,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect1242 || (_rect1242 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 27,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1243 || (_rect1243 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 27,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1244 || (_rect1244 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 27,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1245 || (_rect1245 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 27,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1246 || (_rect1246 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 27,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1247 || (_rect1247 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 27,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1248 || (_rect1248 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 27,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1249 || (_rect1249 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 27,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1250 || (_rect1250 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 27,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1251 || (_rect1251 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 27,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1252 || (_rect1252 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 27,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1253 || (_rect1253 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 27,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1254 || (_rect1254 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 27,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1255 || (_rect1255 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 27,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1256 || (_rect1256 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 27,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1257 || (_rect1257 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 27,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1258 || (_rect1258 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 27,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1259 || (_rect1259 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 27,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1260 || (_rect1260 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 27,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1261 || (_rect1261 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 27,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1262 || (_rect1262 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 27,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1263 || (_rect1263 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1264 || (_rect1264 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1265 || (_rect1265 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 27,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1266 || (_rect1266 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 27,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1267 || (_rect1267 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 27,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1268 || (_rect1268 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1269 || (_rect1269 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1270 || (_rect1270 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1271 || (_rect1271 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1272 || (_rect1272 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 27,
    width: 1,
    height: 1,
    fill: "#CDF884"
  })), _rect1273 || (_rect1273 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 27,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1274 || (_rect1274 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 27,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1275 || (_rect1275 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 27,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1276 || (_rect1276 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 27,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1277 || (_rect1277 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 27,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1278 || (_rect1278 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 27,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1279 || (_rect1279 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 27,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1280 || (_rect1280 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 27,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1281 || (_rect1281 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 27,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1282 || (_rect1282 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 27,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1283 || (_rect1283 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1284 || (_rect1284 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 27,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1285 || (_rect1285 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 27,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1286 || (_rect1286 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 27,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1287 || (_rect1287 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 27,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1288 || (_rect1288 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 27,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1289 || (_rect1289 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 27,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1290 || (_rect1290 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 27,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1291 || (_rect1291 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1292 || (_rect1292 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 28,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1293 || (_rect1293 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 28,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1294 || (_rect1294 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 28,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1295 || (_rect1295 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 28,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1296 || (_rect1296 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 28,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1297 || (_rect1297 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 28,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1298 || (_rect1298 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 28,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect1299 || (_rect1299 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 28,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1300 || (_rect1300 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 28,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1301 || (_rect1301 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 28,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1302 || (_rect1302 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 28,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1303 || (_rect1303 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 28,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1304 || (_rect1304 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 28,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1305 || (_rect1305 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 28,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1306 || (_rect1306 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 28,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1307 || (_rect1307 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 28,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1308 || (_rect1308 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 28,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1309 || (_rect1309 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 28,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1310 || (_rect1310 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 28,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1311 || (_rect1311 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 28,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1312 || (_rect1312 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 28,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1313 || (_rect1313 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 28,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1314 || (_rect1314 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 28,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1315 || (_rect1315 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 28,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1316 || (_rect1316 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 28,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1317 || (_rect1317 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 28,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1318 || (_rect1318 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 28,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1319 || (_rect1319 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1320 || (_rect1320 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 28,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1321 || (_rect1321 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 28,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1322 || (_rect1322 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 28,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1323 || (_rect1323 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 28,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1324 || (_rect1324 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 28,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1325 || (_rect1325 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 28,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1326 || (_rect1326 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 28,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1327 || (_rect1327 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 28,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1328 || (_rect1328 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 28,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1329 || (_rect1329 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 28,
    width: 1,
    height: 1,
    fill: "#CDF884"
  })), _rect1330 || (_rect1330 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 28,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1331 || (_rect1331 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 28,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1332 || (_rect1332 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 28,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1333 || (_rect1333 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 28,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1334 || (_rect1334 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 28,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1335 || (_rect1335 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 28,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1336 || (_rect1336 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 28,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1337 || (_rect1337 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 28,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1338 || (_rect1338 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 28,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1339 || (_rect1339 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 28,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1340 || (_rect1340 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 28,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1341 || (_rect1341 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 28,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1342 || (_rect1342 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 28,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1343 || (_rect1343 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 28,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1344 || (_rect1344 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 28,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1345 || (_rect1345 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 28,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1346 || (_rect1346 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 28,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1347 || (_rect1347 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 28,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1348 || (_rect1348 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 29,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1349 || (_rect1349 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 29,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1350 || (_rect1350 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 29,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1351 || (_rect1351 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 29,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1352 || (_rect1352 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 29,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1353 || (_rect1353 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 29,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1354 || (_rect1354 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 29,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1355 || (_rect1355 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 29,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect1356 || (_rect1356 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 29,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1357 || (_rect1357 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 29,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1358 || (_rect1358 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 29,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1359 || (_rect1359 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 29,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1360 || (_rect1360 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 29,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1361 || (_rect1361 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 29,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1362 || (_rect1362 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 29,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1363 || (_rect1363 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 29,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1364 || (_rect1364 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 29,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1365 || (_rect1365 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 29,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1366 || (_rect1366 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 29,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1367 || (_rect1367 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 29,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1368 || (_rect1368 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 29,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1369 || (_rect1369 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 29,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1370 || (_rect1370 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 29,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1371 || (_rect1371 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 29,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1372 || (_rect1372 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 29,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1373 || (_rect1373 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 29,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1374 || (_rect1374 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 29,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1375 || (_rect1375 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 29,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1376 || (_rect1376 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 29,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1377 || (_rect1377 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 29,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1378 || (_rect1378 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 29,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1379 || (_rect1379 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 29,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1380 || (_rect1380 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 29,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1381 || (_rect1381 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 29,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1382 || (_rect1382 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 29,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1383 || (_rect1383 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 29,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1384 || (_rect1384 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 29,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1385 || (_rect1385 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 29,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1386 || (_rect1386 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 29,
    width: 1,
    height: 1,
    fill: "#CDF884"
  })), _rect1387 || (_rect1387 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 29,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1388 || (_rect1388 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 29,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1389 || (_rect1389 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 29,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1390 || (_rect1390 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 29,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1391 || (_rect1391 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 29,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1392 || (_rect1392 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 29,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1393 || (_rect1393 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 29,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1394 || (_rect1394 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 29,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1395 || (_rect1395 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1396 || (_rect1396 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 29,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1397 || (_rect1397 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 29,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1398 || (_rect1398 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 29,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1399 || (_rect1399 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 29,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1400 || (_rect1400 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 29,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1401 || (_rect1401 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 29,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1402 || (_rect1402 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 29,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1403 || (_rect1403 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 29,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1404 || (_rect1404 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 29,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1405 || (_rect1405 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 30,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1406 || (_rect1406 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 30,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1407 || (_rect1407 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 30,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1408 || (_rect1408 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 30,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1409 || (_rect1409 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 30,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1410 || (_rect1410 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 30,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1411 || (_rect1411 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 30,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1412 || (_rect1412 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 30,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect1413 || (_rect1413 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 30,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1414 || (_rect1414 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 30,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1415 || (_rect1415 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 30,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1416 || (_rect1416 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 30,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1417 || (_rect1417 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 30,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1418 || (_rect1418 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 30,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1419 || (_rect1419 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 30,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1420 || (_rect1420 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 30,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1421 || (_rect1421 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 30,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1422 || (_rect1422 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 30,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1423 || (_rect1423 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 30,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1424 || (_rect1424 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 30,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1425 || (_rect1425 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 30,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1426 || (_rect1426 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 30,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1427 || (_rect1427 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 30,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1428 || (_rect1428 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 30,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1429 || (_rect1429 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 30,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1430 || (_rect1430 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 30,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1431 || (_rect1431 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 30,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1432 || (_rect1432 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1433 || (_rect1433 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1434 || (_rect1434 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 30,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1435 || (_rect1435 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1436 || (_rect1436 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1437 || (_rect1437 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1438 || (_rect1438 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1439 || (_rect1439 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1440 || (_rect1440 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1441 || (_rect1441 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1442 || (_rect1442 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1443 || (_rect1443 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 30,
    width: 1,
    height: 1,
    fill: "#CDF884"
  })), _rect1444 || (_rect1444 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 30,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1445 || (_rect1445 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 30,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1446 || (_rect1446 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 30,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1447 || (_rect1447 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 30,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1448 || (_rect1448 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 30,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1449 || (_rect1449 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 30,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1450 || (_rect1450 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 30,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1451 || (_rect1451 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 30,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1452 || (_rect1452 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 30,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1453 || (_rect1453 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 30,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1454 || (_rect1454 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 30,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1455 || (_rect1455 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 30,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1456 || (_rect1456 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 30,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1457 || (_rect1457 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 30,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1458 || (_rect1458 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 30,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1459 || (_rect1459 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 30,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1460 || (_rect1460 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 30,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1461 || (_rect1461 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 30,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1462 || (_rect1462 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 31,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1463 || (_rect1463 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 31,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1464 || (_rect1464 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 31,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1465 || (_rect1465 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 31,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1466 || (_rect1466 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 31,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1467 || (_rect1467 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 31,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1468 || (_rect1468 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 31,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1469 || (_rect1469 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 31,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect1470 || (_rect1470 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 31,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1471 || (_rect1471 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 31,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1472 || (_rect1472 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 31,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1473 || (_rect1473 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 31,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1474 || (_rect1474 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 31,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1475 || (_rect1475 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 31,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1476 || (_rect1476 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 31,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1477 || (_rect1477 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 31,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1478 || (_rect1478 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 31,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1479 || (_rect1479 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 31,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1480 || (_rect1480 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 31,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1481 || (_rect1481 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 31,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1482 || (_rect1482 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 31,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1483 || (_rect1483 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 31,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1484 || (_rect1484 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 31,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1485 || (_rect1485 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 31,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1486 || (_rect1486 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 31,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1487 || (_rect1487 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 31,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1488 || (_rect1488 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1489 || (_rect1489 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1490 || (_rect1490 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 31,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1491 || (_rect1491 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 31,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1492 || (_rect1492 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 31,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1493 || (_rect1493 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1494 || (_rect1494 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1495 || (_rect1495 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1496 || (_rect1496 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1497 || (_rect1497 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1498 || (_rect1498 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1499 || (_rect1499 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1500 || (_rect1500 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 31,
    width: 1,
    height: 1,
    fill: "#CDF884"
  })), _rect1501 || (_rect1501 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 31,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1502 || (_rect1502 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 31,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1503 || (_rect1503 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 31,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1504 || (_rect1504 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 31,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1505 || (_rect1505 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 31,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1506 || (_rect1506 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 31,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1507 || (_rect1507 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 31,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1508 || (_rect1508 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 31,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1509 || (_rect1509 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 31,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1510 || (_rect1510 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 31,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1511 || (_rect1511 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 31,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1512 || (_rect1512 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 31,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1513 || (_rect1513 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 31,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1514 || (_rect1514 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 31,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1515 || (_rect1515 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 31,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1516 || (_rect1516 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 31,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1517 || (_rect1517 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 31,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1518 || (_rect1518 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 31,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1519 || (_rect1519 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 32,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1520 || (_rect1520 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 32,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1521 || (_rect1521 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 32,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1522 || (_rect1522 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 32,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1523 || (_rect1523 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 32,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1524 || (_rect1524 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 32,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1525 || (_rect1525 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 32,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1526 || (_rect1526 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 32,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect1527 || (_rect1527 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 32,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1528 || (_rect1528 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 32,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1529 || (_rect1529 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 32,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1530 || (_rect1530 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 32,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1531 || (_rect1531 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 32,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1532 || (_rect1532 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 32,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1533 || (_rect1533 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 32,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1534 || (_rect1534 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 32,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1535 || (_rect1535 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 32,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1536 || (_rect1536 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 32,
    width: 1,
    height: 1,
    fill: "#FFFFF9"
  })), _rect1537 || (_rect1537 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 32,
    width: 1,
    height: 1,
    fill: "#FFFFF9"
  })), _rect1538 || (_rect1538 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 32,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1539 || (_rect1539 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 32,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1540 || (_rect1540 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 32,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1541 || (_rect1541 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 32,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1542 || (_rect1542 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 32,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1543 || (_rect1543 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 32,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1544 || (_rect1544 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1545 || (_rect1545 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1546 || (_rect1546 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 32,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1547 || (_rect1547 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 32,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1548 || (_rect1548 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 32,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1549 || (_rect1549 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1550 || (_rect1550 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1551 || (_rect1551 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1552 || (_rect1552 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1553 || (_rect1553 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1554 || (_rect1554 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1555 || (_rect1555 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1556 || (_rect1556 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1557 || (_rect1557 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 32,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1558 || (_rect1558 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 32,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1559 || (_rect1559 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 32,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1560 || (_rect1560 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 32,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1561 || (_rect1561 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 32,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1562 || (_rect1562 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 32,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1563 || (_rect1563 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 32,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1564 || (_rect1564 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 32,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1565 || (_rect1565 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 32,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1566 || (_rect1566 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 32,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1567 || (_rect1567 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 32,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1568 || (_rect1568 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 32,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1569 || (_rect1569 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 32,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1570 || (_rect1570 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 32,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1571 || (_rect1571 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 32,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1572 || (_rect1572 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 32,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1573 || (_rect1573 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 32,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1574 || (_rect1574 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 32,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1575 || (_rect1575 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 32,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1576 || (_rect1576 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1577 || (_rect1577 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 33,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1578 || (_rect1578 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 33,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1579 || (_rect1579 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 33,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1580 || (_rect1580 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 33,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1581 || (_rect1581 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 33,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1582 || (_rect1582 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 33,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1583 || (_rect1583 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 33,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect1584 || (_rect1584 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 33,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1585 || (_rect1585 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 33,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1586 || (_rect1586 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 33,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1587 || (_rect1587 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 33,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1588 || (_rect1588 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 33,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1589 || (_rect1589 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 33,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1590 || (_rect1590 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 33,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1591 || (_rect1591 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 33,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1592 || (_rect1592 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 33,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1593 || (_rect1593 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 33,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1594 || (_rect1594 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 33,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1595 || (_rect1595 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 33,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1596 || (_rect1596 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 33,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1597 || (_rect1597 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 33,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1598 || (_rect1598 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 33,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1599 || (_rect1599 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 33,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1600 || (_rect1600 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1601 || (_rect1601 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1602 || (_rect1602 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 33,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1603 || (_rect1603 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 33,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1604 || (_rect1604 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 33,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1605 || (_rect1605 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1606 || (_rect1606 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1607 || (_rect1607 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1608 || (_rect1608 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1609 || (_rect1609 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1610 || (_rect1610 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1611 || (_rect1611 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1612 || (_rect1612 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1613 || (_rect1613 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 33,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1614 || (_rect1614 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 33,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1615 || (_rect1615 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 33,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1616 || (_rect1616 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 33,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1617 || (_rect1617 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 33,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1618 || (_rect1618 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 33,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1619 || (_rect1619 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 33,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1620 || (_rect1620 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 33,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1621 || (_rect1621 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 33,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1622 || (_rect1622 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 33,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1623 || (_rect1623 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 33,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1624 || (_rect1624 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 33,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1625 || (_rect1625 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 33,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1626 || (_rect1626 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 33,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1627 || (_rect1627 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 33,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1628 || (_rect1628 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 33,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1629 || (_rect1629 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 33,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1630 || (_rect1630 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 33,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1631 || (_rect1631 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 33,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1632 || (_rect1632 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 33,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1633 || (_rect1633 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 34,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1634 || (_rect1634 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 34,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1635 || (_rect1635 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 34,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1636 || (_rect1636 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 34,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1637 || (_rect1637 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 34,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1638 || (_rect1638 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 34,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1639 || (_rect1639 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 34,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1640 || (_rect1640 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 34,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect1641 || (_rect1641 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 34,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1642 || (_rect1642 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 34,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1643 || (_rect1643 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 34,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1644 || (_rect1644 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 34,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1645 || (_rect1645 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 34,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1646 || (_rect1646 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 34,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1647 || (_rect1647 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 34,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1648 || (_rect1648 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 34,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1649 || (_rect1649 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 34,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1650 || (_rect1650 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 34,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1651 || (_rect1651 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 34,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1652 || (_rect1652 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 34,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1653 || (_rect1653 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 34,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1654 || (_rect1654 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 34,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1655 || (_rect1655 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 34,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1656 || (_rect1656 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1657 || (_rect1657 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1658 || (_rect1658 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 34,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1659 || (_rect1659 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 34,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1660 || (_rect1660 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 34,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1661 || (_rect1661 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1662 || (_rect1662 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1663 || (_rect1663 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1664 || (_rect1664 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1665 || (_rect1665 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1666 || (_rect1666 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1667 || (_rect1667 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1668 || (_rect1668 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1669 || (_rect1669 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 34,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1670 || (_rect1670 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 34,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1671 || (_rect1671 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 34,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1672 || (_rect1672 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 34,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1673 || (_rect1673 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 34,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1674 || (_rect1674 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 34,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1675 || (_rect1675 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 34,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1676 || (_rect1676 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 34,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1677 || (_rect1677 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 34,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1678 || (_rect1678 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 34,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1679 || (_rect1679 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 34,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1680 || (_rect1680 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 34,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1681 || (_rect1681 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 34,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1682 || (_rect1682 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 34,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1683 || (_rect1683 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 34,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1684 || (_rect1684 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 34,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1685 || (_rect1685 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 34,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1686 || (_rect1686 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 34,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1687 || (_rect1687 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 34,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1688 || (_rect1688 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 34,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1689 || (_rect1689 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 34,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1690 || (_rect1690 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 35,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1691 || (_rect1691 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 35,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1692 || (_rect1692 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 35,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1693 || (_rect1693 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 35,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1694 || (_rect1694 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 35,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1695 || (_rect1695 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 35,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1696 || (_rect1696 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 35,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1697 || (_rect1697 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 35,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect1698 || (_rect1698 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 35,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1699 || (_rect1699 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 35,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1700 || (_rect1700 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 35,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1701 || (_rect1701 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 35,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1702 || (_rect1702 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 35,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1703 || (_rect1703 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 35,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1704 || (_rect1704 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 35,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1705 || (_rect1705 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 35,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1706 || (_rect1706 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 35,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1707 || (_rect1707 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 35,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1708 || (_rect1708 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 35,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1709 || (_rect1709 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 35,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1710 || (_rect1710 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 35,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1711 || (_rect1711 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 35,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1712 || (_rect1712 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 35,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1713 || (_rect1713 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1714 || (_rect1714 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 35,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1715 || (_rect1715 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 35,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1716 || (_rect1716 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 35,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1717 || (_rect1717 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1718 || (_rect1718 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1719 || (_rect1719 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1720 || (_rect1720 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1721 || (_rect1721 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1722 || (_rect1722 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1723 || (_rect1723 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1724 || (_rect1724 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1725 || (_rect1725 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 35,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1726 || (_rect1726 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 35,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1727 || (_rect1727 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 35,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1728 || (_rect1728 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 35,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1729 || (_rect1729 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 35,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1730 || (_rect1730 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 35,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1731 || (_rect1731 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 35,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1732 || (_rect1732 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 35,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1733 || (_rect1733 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 35,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1734 || (_rect1734 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 35,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1735 || (_rect1735 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 35,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1736 || (_rect1736 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 35,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect1737 || (_rect1737 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 35,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1738 || (_rect1738 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 35,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1739 || (_rect1739 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 35,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1740 || (_rect1740 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 35,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1741 || (_rect1741 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 35,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1742 || (_rect1742 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 35,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1743 || (_rect1743 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 35,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1744 || (_rect1744 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 35,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1745 || (_rect1745 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 35,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1746 || (_rect1746 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 35,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1747 || (_rect1747 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 36,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1748 || (_rect1748 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 36,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1749 || (_rect1749 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 36,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1750 || (_rect1750 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 36,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1751 || (_rect1751 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 36,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1752 || (_rect1752 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 36,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1753 || (_rect1753 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 36,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1754 || (_rect1754 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 36,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect1755 || (_rect1755 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 36,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1756 || (_rect1756 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 36,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1757 || (_rect1757 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 36,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1758 || (_rect1758 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 36,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1759 || (_rect1759 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 36,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1760 || (_rect1760 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 36,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1761 || (_rect1761 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 36,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1762 || (_rect1762 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 36,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1763 || (_rect1763 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 36,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1764 || (_rect1764 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 36,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1765 || (_rect1765 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 36,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1766 || (_rect1766 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 36,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1767 || (_rect1767 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 36,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1768 || (_rect1768 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 36,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1769 || (_rect1769 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 36,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1770 || (_rect1770 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 36,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1771 || (_rect1771 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 36,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1772 || (_rect1772 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 36,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1773 || (_rect1773 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 36,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1774 || (_rect1774 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 36,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1775 || (_rect1775 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 36,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1776 || (_rect1776 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 36,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1777 || (_rect1777 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 36,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1778 || (_rect1778 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 36,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1779 || (_rect1779 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 36,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1780 || (_rect1780 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 36,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1781 || (_rect1781 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 36,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1782 || (_rect1782 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1783 || (_rect1783 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 36,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1784 || (_rect1784 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 36,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1785 || (_rect1785 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 36,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1786 || (_rect1786 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 36,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1787 || (_rect1787 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1788 || (_rect1788 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 36,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1789 || (_rect1789 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 36,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1790 || (_rect1790 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 36,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1791 || (_rect1791 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 36,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1792 || (_rect1792 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 36,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1793 || (_rect1793 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 36,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1794 || (_rect1794 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 36,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1795 || (_rect1795 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 36,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1796 || (_rect1796 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 36,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1797 || (_rect1797 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 36,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1798 || (_rect1798 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 36,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1799 || (_rect1799 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 36,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1800 || (_rect1800 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 36,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1801 || (_rect1801 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 36,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1802 || (_rect1802 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 36,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1803 || (_rect1803 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 36,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1804 || (_rect1804 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 37,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1805 || (_rect1805 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 37,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1806 || (_rect1806 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 37,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1807 || (_rect1807 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 37,
    width: 1,
    height: 1,
    fill: "#FFE383"
  })), _rect1808 || (_rect1808 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 37,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1809 || (_rect1809 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 37,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1810 || (_rect1810 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 37,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1811 || (_rect1811 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 37,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1812 || (_rect1812 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 37,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1813 || (_rect1813 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 37,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1814 || (_rect1814 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 37,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1815 || (_rect1815 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 37,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1816 || (_rect1816 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 37,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1817 || (_rect1817 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 37,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1818 || (_rect1818 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 37,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1819 || (_rect1819 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 37,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1820 || (_rect1820 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 37,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1821 || (_rect1821 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 37,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1822 || (_rect1822 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 37,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1823 || (_rect1823 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 37,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1824 || (_rect1824 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 37,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1825 || (_rect1825 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 37,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1826 || (_rect1826 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 37,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1827 || (_rect1827 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 37,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1828 || (_rect1828 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 37,
    width: 1,
    height: 1,
    fill: "#E6FF9E"
  })), _rect1829 || (_rect1829 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 37,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1830 || (_rect1830 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 37,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1831 || (_rect1831 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 37,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1832 || (_rect1832 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 37,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1833 || (_rect1833 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 37,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1834 || (_rect1834 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 37,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1835 || (_rect1835 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 37,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1836 || (_rect1836 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 37,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect1837 || (_rect1837 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 37,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1838 || (_rect1838 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 37,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1839 || (_rect1839 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 37,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1840 || (_rect1840 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 37,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1841 || (_rect1841 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 37,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1842 || (_rect1842 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 37,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1843 || (_rect1843 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 37,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1844 || (_rect1844 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 37,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1845 || (_rect1845 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 37,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1846 || (_rect1846 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 37,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1847 || (_rect1847 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 37,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1848 || (_rect1848 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 37,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1849 || (_rect1849 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 37,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1850 || (_rect1850 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 37,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1851 || (_rect1851 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 37,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1852 || (_rect1852 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 37,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1853 || (_rect1853 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 37,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1854 || (_rect1854 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 37,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1855 || (_rect1855 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 37,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1856 || (_rect1856 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 37,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1857 || (_rect1857 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 37,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect1858 || (_rect1858 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 37,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1859 || (_rect1859 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 37,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1860 || (_rect1860 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 37,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1861 || (_rect1861 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 38,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1862 || (_rect1862 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 38,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1863 || (_rect1863 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 38,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1864 || (_rect1864 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 38,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1865 || (_rect1865 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 38,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1866 || (_rect1866 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 38,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1867 || (_rect1867 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 38,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1868 || (_rect1868 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 38,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1869 || (_rect1869 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 38,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1870 || (_rect1870 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 38,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1871 || (_rect1871 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 38,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1872 || (_rect1872 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 38,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1873 || (_rect1873 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1874 || (_rect1874 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 38,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1875 || (_rect1875 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 38,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1876 || (_rect1876 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 38,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1877 || (_rect1877 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 38,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1878 || (_rect1878 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 38,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1879 || (_rect1879 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 38,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1880 || (_rect1880 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 38,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1881 || (_rect1881 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 38,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1882 || (_rect1882 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 38,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1883 || (_rect1883 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 38,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1884 || (_rect1884 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 38,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1885 || (_rect1885 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 38,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1886 || (_rect1886 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 38,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1887 || (_rect1887 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 38,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1888 || (_rect1888 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 38,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1889 || (_rect1889 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 38,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1890 || (_rect1890 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 38,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1891 || (_rect1891 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 38,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1892 || (_rect1892 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 38,
    width: 1,
    height: 1,
    fill: "#B5F759"
  })), _rect1893 || (_rect1893 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 38,
    width: 1,
    height: 1,
    fill: "#CDF884"
  })), _rect1894 || (_rect1894 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 38,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1895 || (_rect1895 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 38,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1896 || (_rect1896 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 38,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1897 || (_rect1897 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 38,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1898 || (_rect1898 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 38,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1899 || (_rect1899 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 38,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1900 || (_rect1900 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 38,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1901 || (_rect1901 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 38,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1902 || (_rect1902 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 38,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1903 || (_rect1903 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 38,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1904 || (_rect1904 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 38,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1905 || (_rect1905 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 38,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1906 || (_rect1906 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 38,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1907 || (_rect1907 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 38,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1908 || (_rect1908 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 38,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1909 || (_rect1909 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 38,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1910 || (_rect1910 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1911 || (_rect1911 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 38,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1912 || (_rect1912 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 38,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1913 || (_rect1913 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 38,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect1914 || (_rect1914 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 38,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect1915 || (_rect1915 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 38,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect1916 || (_rect1916 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 38,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1917 || (_rect1917 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 38,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1918 || (_rect1918 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 39,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1919 || (_rect1919 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 39,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1920 || (_rect1920 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 39,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1921 || (_rect1921 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 39,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1922 || (_rect1922 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 39,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1923 || (_rect1923 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 39,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1924 || (_rect1924 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1925 || (_rect1925 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1926 || (_rect1926 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1927 || (_rect1927 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 39,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1928 || (_rect1928 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1929 || (_rect1929 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1930 || (_rect1930 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 39,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1931 || (_rect1931 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 39,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1932 || (_rect1932 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 39,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1933 || (_rect1933 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1934 || (_rect1934 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1935 || (_rect1935 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1936 || (_rect1936 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1937 || (_rect1937 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 39,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1938 || (_rect1938 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 39,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1939 || (_rect1939 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 39,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1940 || (_rect1940 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 39,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1941 || (_rect1941 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 39,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1942 || (_rect1942 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect1943 || (_rect1943 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 39,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1944 || (_rect1944 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 39,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1945 || (_rect1945 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 39,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1946 || (_rect1946 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 39,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1947 || (_rect1947 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 39,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1948 || (_rect1948 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 39,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1949 || (_rect1949 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 39,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1950 || (_rect1950 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 39,
    width: 1,
    height: 1,
    fill: "#CDF884"
  })), _rect1951 || (_rect1951 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 39,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1952 || (_rect1952 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 39,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect1953 || (_rect1953 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 39,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1954 || (_rect1954 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 39,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1955 || (_rect1955 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 39,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1956 || (_rect1956 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1957 || (_rect1957 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1958 || (_rect1958 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1959 || (_rect1959 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1960 || (_rect1960 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 39,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1961 || (_rect1961 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 39,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect1962 || (_rect1962 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 39,
    width: 1,
    height: 1,
    fill: "#14391D"
  })), _rect1963 || (_rect1963 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1964 || (_rect1964 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1965 || (_rect1965 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 39,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1966 || (_rect1966 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1967 || (_rect1967 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1968 || (_rect1968 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 39,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1969 || (_rect1969 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 39,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect1970 || (_rect1970 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 39,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect1971 || (_rect1971 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 39,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect1972 || (_rect1972 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 39,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1973 || (_rect1973 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 39,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1974 || (_rect1974 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 39,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1975 || (_rect1975 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 40,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1976 || (_rect1976 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 40,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1977 || (_rect1977 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 40,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect1978 || (_rect1978 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 40,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1979 || (_rect1979 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 40,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1980 || (_rect1980 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 40,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1981 || (_rect1981 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 40,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1982 || (_rect1982 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 40,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1983 || (_rect1983 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 40,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect1984 || (_rect1984 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 40,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect1985 || (_rect1985 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 40,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1986 || (_rect1986 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 40,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1987 || (_rect1987 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 40,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1988 || (_rect1988 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 40,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1989 || (_rect1989 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 40,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1990 || (_rect1990 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 40,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect1991 || (_rect1991 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 40,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect1992 || (_rect1992 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 40,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1993 || (_rect1993 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 40,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1994 || (_rect1994 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 40,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1995 || (_rect1995 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 40,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect1996 || (_rect1996 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 40,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1997 || (_rect1997 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 40,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect1998 || (_rect1998 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 40,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect1999 || (_rect1999 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 40,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2000 || (_rect2000 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 40,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2001 || (_rect2001 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 40,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2002 || (_rect2002 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 40,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2003 || (_rect2003 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 40,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2004 || (_rect2004 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 40,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2005 || (_rect2005 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 40,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2006 || (_rect2006 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 40,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2007 || (_rect2007 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 40,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2008 || (_rect2008 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 40,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2009 || (_rect2009 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 40,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2010 || (_rect2010 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 40,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2011 || (_rect2011 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 40,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2012 || (_rect2012 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 40,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect2013 || (_rect2013 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 40,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2014 || (_rect2014 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect2015 || (_rect2015 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 40,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2016 || (_rect2016 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 40,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2017 || (_rect2017 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 40,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2018 || (_rect2018 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 40,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2019 || (_rect2019 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 40,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2020 || (_rect2020 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 40,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2021 || (_rect2021 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 40,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2022 || (_rect2022 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 40,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2023 || (_rect2023 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2024 || (_rect2024 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 40,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2025 || (_rect2025 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 40,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2026 || (_rect2026 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 40,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2027 || (_rect2027 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 40,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2028 || (_rect2028 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 40,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2029 || (_rect2029 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 40,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2030 || (_rect2030 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 41,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2031 || (_rect2031 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 41,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2032 || (_rect2032 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 41,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2033 || (_rect2033 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 41,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2034 || (_rect2034 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 41,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2035 || (_rect2035 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 41,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2036 || (_rect2036 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 41,
    width: 1,
    height: 1,
    fill: "#FFFFCB"
  })), _rect2037 || (_rect2037 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 41,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect2038 || (_rect2038 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 41,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect2039 || (_rect2039 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 41,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect2040 || (_rect2040 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 41,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2041 || (_rect2041 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 41,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2042 || (_rect2042 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 41,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2043 || (_rect2043 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 41,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2044 || (_rect2044 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 41,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2045 || (_rect2045 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 41,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2046 || (_rect2046 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 41,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2047 || (_rect2047 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 41,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2048 || (_rect2048 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 41,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2049 || (_rect2049 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 41,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2050 || (_rect2050 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 41,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2051 || (_rect2051 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 41,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect2052 || (_rect2052 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 41,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2053 || (_rect2053 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 41,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2054 || (_rect2054 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 41,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2055 || (_rect2055 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 41,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2056 || (_rect2056 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 41,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2057 || (_rect2057 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 41,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2058 || (_rect2058 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 41,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2059 || (_rect2059 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 41,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2060 || (_rect2060 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 41,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2061 || (_rect2061 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 41,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect2062 || (_rect2062 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 41,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2063 || (_rect2063 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 41,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2064 || (_rect2064 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 41,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2065 || (_rect2065 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 41,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2066 || (_rect2066 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 41,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect2067 || (_rect2067 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 41,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2068 || (_rect2068 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 41,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2069 || (_rect2069 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 41,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2070 || (_rect2070 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 41,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2071 || (_rect2071 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 41,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2072 || (_rect2072 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 41,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2073 || (_rect2073 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 41,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect2074 || (_rect2074 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 41,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2075 || (_rect2075 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 41,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2076 || (_rect2076 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 41,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2077 || (_rect2077 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2078 || (_rect2078 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2079 || (_rect2079 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2080 || (_rect2080 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 41,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2081 || (_rect2081 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 41,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2082 || (_rect2082 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 41,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2083 || (_rect2083 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 42,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2084 || (_rect2084 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 42,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2085 || (_rect2085 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 42,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2086 || (_rect2086 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 42,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2087 || (_rect2087 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 42,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2088 || (_rect2088 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 42,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2089 || (_rect2089 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 42,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect2090 || (_rect2090 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 42,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect2091 || (_rect2091 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 42,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2092 || (_rect2092 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 42,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2093 || (_rect2093 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 42,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2094 || (_rect2094 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 42,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2095 || (_rect2095 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 42,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2096 || (_rect2096 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 42,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2097 || (_rect2097 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 42,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2098 || (_rect2098 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 42,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2099 || (_rect2099 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 42,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2100 || (_rect2100 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 42,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2101 || (_rect2101 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 42,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2102 || (_rect2102 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 42,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2103 || (_rect2103 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 42,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect2104 || (_rect2104 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 42,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2105 || (_rect2105 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 42,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2106 || (_rect2106 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 42,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2107 || (_rect2107 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 42,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2108 || (_rect2108 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 42,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2109 || (_rect2109 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 42,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2110 || (_rect2110 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 42,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2111 || (_rect2111 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 42,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2112 || (_rect2112 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 42,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2113 || (_rect2113 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 42,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect2114 || (_rect2114 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 42,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2115 || (_rect2115 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 42,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2116 || (_rect2116 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 42,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2117 || (_rect2117 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 42,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2118 || (_rect2118 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 42,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2119 || (_rect2119 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 42,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect2120 || (_rect2120 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 42,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2121 || (_rect2121 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 42,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2122 || (_rect2122 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2123 || (_rect2123 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 42,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2124 || (_rect2124 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 42,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2125 || (_rect2125 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 42,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2126 || (_rect2126 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 42,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2127 || (_rect2127 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 42,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2128 || (_rect2128 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2129 || (_rect2129 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2130 || (_rect2130 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2131 || (_rect2131 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 42,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2132 || (_rect2132 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 42,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2133 || (_rect2133 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 42,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2134 || (_rect2134 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 43,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2135 || (_rect2135 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 43,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2136 || (_rect2136 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 43,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2137 || (_rect2137 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 43,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2138 || (_rect2138 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 43,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2139 || (_rect2139 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 43,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2140 || (_rect2140 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 43,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect2141 || (_rect2141 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 43,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect2142 || (_rect2142 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 43,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2143 || (_rect2143 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 43,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2144 || (_rect2144 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 43,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2145 || (_rect2145 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 43,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2146 || (_rect2146 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 43,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2147 || (_rect2147 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 43,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2148 || (_rect2148 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 43,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2149 || (_rect2149 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 43,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2150 || (_rect2150 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 43,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2151 || (_rect2151 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 43,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2152 || (_rect2152 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 43,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect2153 || (_rect2153 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 43,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2154 || (_rect2154 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 43,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2155 || (_rect2155 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 43,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2156 || (_rect2156 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 43,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2157 || (_rect2157 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 43,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2158 || (_rect2158 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 43,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2159 || (_rect2159 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 43,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2160 || (_rect2160 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 43,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2161 || (_rect2161 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 43,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2162 || (_rect2162 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 43,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2163 || (_rect2163 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 43,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2164 || (_rect2164 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 43,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect2165 || (_rect2165 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 43,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2166 || (_rect2166 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 43,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2167 || (_rect2167 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 43,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2168 || (_rect2168 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 43,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2169 || (_rect2169 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 43,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect2170 || (_rect2170 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 43,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2171 || (_rect2171 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 43,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2172 || (_rect2172 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 43,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2173 || (_rect2173 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 43,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2174 || (_rect2174 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 43,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2175 || (_rect2175 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 43,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2176 || (_rect2176 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 43,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2177 || (_rect2177 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2178 || (_rect2178 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2179 || (_rect2179 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2180 || (_rect2180 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 43,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2181 || (_rect2181 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 43,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2182 || (_rect2182 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 43,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2183 || (_rect2183 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 44,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2184 || (_rect2184 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 44,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2185 || (_rect2185 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 44,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2186 || (_rect2186 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 44,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2187 || (_rect2187 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 44,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2188 || (_rect2188 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 44,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2189 || (_rect2189 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 44,
    width: 1,
    height: 1,
    fill: "#FFFBA5"
  })), _rect2190 || (_rect2190 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 44,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2191 || (_rect2191 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 44,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2192 || (_rect2192 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 44,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2193 || (_rect2193 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 44,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2194 || (_rect2194 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 44,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2195 || (_rect2195 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 44,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2196 || (_rect2196 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 44,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect2197 || (_rect2197 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 44,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2198 || (_rect2198 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 44,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2199 || (_rect2199 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 44,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2200 || (_rect2200 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 44,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect2201 || (_rect2201 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 44,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2202 || (_rect2202 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 44,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2203 || (_rect2203 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 44,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2204 || (_rect2204 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 44,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2205 || (_rect2205 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 44,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2206 || (_rect2206 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 44,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2207 || (_rect2207 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 44,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2208 || (_rect2208 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 44,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2209 || (_rect2209 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 44,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2210 || (_rect2210 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 44,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2211 || (_rect2211 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 44,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2212 || (_rect2212 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 44,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect2213 || (_rect2213 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 44,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2214 || (_rect2214 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 44,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2215 || (_rect2215 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 44,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2216 || (_rect2216 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 44,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2217 || (_rect2217 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 44,
    width: 1,
    height: 1,
    fill: "#14391D"
  })), _rect2218 || (_rect2218 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 44,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2219 || (_rect2219 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 44,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2220 || (_rect2220 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 44,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2221 || (_rect2221 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 44,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2222 || (_rect2222 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 44,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2223 || (_rect2223 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 44,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2224 || (_rect2224 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2225 || (_rect2225 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2226 || (_rect2226 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2227 || (_rect2227 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 44,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2228 || (_rect2228 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 44,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2229 || (_rect2229 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 44,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2230 || (_rect2230 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 45,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2231 || (_rect2231 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 45,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2232 || (_rect2232 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 45,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2233 || (_rect2233 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 45,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2234 || (_rect2234 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2235 || (_rect2235 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 45,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2236 || (_rect2236 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 45,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2237 || (_rect2237 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 45,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2238 || (_rect2238 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 45,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2239 || (_rect2239 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 45,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect2240 || (_rect2240 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 45,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2241 || (_rect2241 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 45,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2242 || (_rect2242 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 45,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2243 || (_rect2243 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 45,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect2244 || (_rect2244 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 45,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2245 || (_rect2245 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 45,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2246 || (_rect2246 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 45,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2247 || (_rect2247 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 45,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2248 || (_rect2248 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 45,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2249 || (_rect2249 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 45,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2250 || (_rect2250 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 45,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2251 || (_rect2251 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 45,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2252 || (_rect2252 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 45,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2253 || (_rect2253 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 45,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2254 || (_rect2254 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 45,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2255 || (_rect2255 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 45,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2256 || (_rect2256 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 45,
    width: 1,
    height: 1,
    fill: "#25AE27"
  })), _rect2257 || (_rect2257 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 45,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2258 || (_rect2258 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 45,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2259 || (_rect2259 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 45,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2260 || (_rect2260 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 45,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2261 || (_rect2261 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 45,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2262 || (_rect2262 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 45,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect2263 || (_rect2263 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 45,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2264 || (_rect2264 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 45,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2265 || (_rect2265 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 45,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect2266 || (_rect2266 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 45,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2267 || (_rect2267 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 45,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2268 || (_rect2268 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 45,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2269 || (_rect2269 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2270 || (_rect2270 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2271 || (_rect2271 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2272 || (_rect2272 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 45,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2273 || (_rect2273 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 45,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2274 || (_rect2274 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 45,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2275 || (_rect2275 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 46,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2276 || (_rect2276 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 46,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2277 || (_rect2277 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 46,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2278 || (_rect2278 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 46,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2279 || (_rect2279 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 46,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2280 || (_rect2280 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 46,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2281 || (_rect2281 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 46,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2282 || (_rect2282 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 46,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2283 || (_rect2283 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 46,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2284 || (_rect2284 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 46,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2285 || (_rect2285 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 46,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2286 || (_rect2286 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 46,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2287 || (_rect2287 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 46,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2288 || (_rect2288 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 46,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2289 || (_rect2289 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 46,
    width: 1,
    height: 1,
    fill: "#A4E95B"
  })), _rect2290 || (_rect2290 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 46,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2291 || (_rect2291 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 46,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2292 || (_rect2292 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 46,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2293 || (_rect2293 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 46,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2294 || (_rect2294 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 46,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2295 || (_rect2295 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 46,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2296 || (_rect2296 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 46,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2297 || (_rect2297 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 46,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2298 || (_rect2298 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 46,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2299 || (_rect2299 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 46,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2300 || (_rect2300 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 46,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2301 || (_rect2301 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 46,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2302 || (_rect2302 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 46,
    width: 1,
    height: 1,
    fill: "#65C037"
  })), _rect2303 || (_rect2303 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 46,
    width: 1,
    height: 1,
    fill: "#97DE5C"
  })), _rect2304 || (_rect2304 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 46,
    width: 1,
    height: 1,
    fill: "#459830"
  })), _rect2305 || (_rect2305 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 46,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect2306 || (_rect2306 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 46,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2307 || (_rect2307 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 46,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2308 || (_rect2308 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 46,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2309 || (_rect2309 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 46,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2310 || (_rect2310 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 46,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2311 || (_rect2311 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 46,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2312 || (_rect2312 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2313 || (_rect2313 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2314 || (_rect2314 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2315 || (_rect2315 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 46,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2316 || (_rect2316 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 46,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2317 || (_rect2317 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 46,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2318 || (_rect2318 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 47,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2319 || (_rect2319 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 47,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2320 || (_rect2320 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 47,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2321 || (_rect2321 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 47,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2322 || (_rect2322 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 47,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2323 || (_rect2323 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 47,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2324 || (_rect2324 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 47,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2325 || (_rect2325 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 47,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2326 || (_rect2326 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 47,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2327 || (_rect2327 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 47,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2328 || (_rect2328 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 47,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2329 || (_rect2329 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 47,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2330 || (_rect2330 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 47,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect2331 || (_rect2331 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 47,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2332 || (_rect2332 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 47,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2333 || (_rect2333 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 47,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2334 || (_rect2334 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 47,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2335 || (_rect2335 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 47,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2336 || (_rect2336 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 47,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2337 || (_rect2337 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 47,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2338 || (_rect2338 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 47,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2339 || (_rect2339 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 47,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2340 || (_rect2340 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 47,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2341 || (_rect2341 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 47,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2342 || (_rect2342 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 47,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2343 || (_rect2343 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 47,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2344 || (_rect2344 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 47,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2345 || (_rect2345 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 47,
    width: 1,
    height: 1,
    fill: "#496E1E"
  })), _rect2346 || (_rect2346 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 47,
    width: 1,
    height: 1,
    fill: "#205E2E"
  })), _rect2347 || (_rect2347 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 47,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2348 || (_rect2348 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 47,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2349 || (_rect2349 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 47,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2350 || (_rect2350 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 47,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2351 || (_rect2351 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 47,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2352 || (_rect2352 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 47,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2353 || (_rect2353 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2354 || (_rect2354 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2355 || (_rect2355 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2356 || (_rect2356 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 47,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2357 || (_rect2357 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 47,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2358 || (_rect2358 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 47,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2359 || (_rect2359 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 48,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2360 || (_rect2360 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 48,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2361 || (_rect2361 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 48,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2362 || (_rect2362 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 48,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2363 || (_rect2363 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 48,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2364 || (_rect2364 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 48,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2365 || (_rect2365 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2366 || (_rect2366 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2367 || (_rect2367 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2368 || (_rect2368 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 48,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2369 || (_rect2369 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2370 || (_rect2370 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2371 || (_rect2371 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2372 || (_rect2372 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2373 || (_rect2373 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2374 || (_rect2374 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2375 || (_rect2375 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2376 || (_rect2376 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2377 || (_rect2377 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2378 || (_rect2378 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2379 || (_rect2379 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2380 || (_rect2380 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2381 || (_rect2381 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2382 || (_rect2382 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2383 || (_rect2383 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2384 || (_rect2384 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2385 || (_rect2385 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2386 || (_rect2386 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2387 || (_rect2387 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2388 || (_rect2388 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 48,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2389 || (_rect2389 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2390 || (_rect2390 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2391 || (_rect2391 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 48,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2392 || (_rect2392 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2393 || (_rect2393 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2394 || (_rect2394 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2395 || (_rect2395 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 48,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2396 || (_rect2396 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 48,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2397 || (_rect2397 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 48,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2398 || (_rect2398 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 49,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2399 || (_rect2399 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 49,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2400 || (_rect2400 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 49,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2401 || (_rect2401 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2402 || (_rect2402 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2403 || (_rect2403 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2404 || (_rect2404 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 49,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2405 || (_rect2405 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 49,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2406 || (_rect2406 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 49,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2407 || (_rect2407 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 49,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect2408 || (_rect2408 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2409 || (_rect2409 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2410 || (_rect2410 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2411 || (_rect2411 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2412 || (_rect2412 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2413 || (_rect2413 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2414 || (_rect2414 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2415 || (_rect2415 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2416 || (_rect2416 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2417 || (_rect2417 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2418 || (_rect2418 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2419 || (_rect2419 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2420 || (_rect2420 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2421 || (_rect2421 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2422 || (_rect2422 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2423 || (_rect2423 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2424 || (_rect2424 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 49,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2425 || (_rect2425 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 49,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect2426 || (_rect2426 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 49,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2427 || (_rect2427 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 49,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2428 || (_rect2428 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 49,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2429 || (_rect2429 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2430 || (_rect2430 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2431 || (_rect2431 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2432 || (_rect2432 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 49,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2433 || (_rect2433 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 49,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2434 || (_rect2434 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 49,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2435 || (_rect2435 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 50,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2436 || (_rect2436 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 50,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2437 || (_rect2437 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 50,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2438 || (_rect2438 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 50,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2439 || (_rect2439 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 50,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2440 || (_rect2440 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 50,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2441 || (_rect2441 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2442 || (_rect2442 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2443 || (_rect2443 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2444 || (_rect2444 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2445 || (_rect2445 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2446 || (_rect2446 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2447 || (_rect2447 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2448 || (_rect2448 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2449 || (_rect2449 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2450 || (_rect2450 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2451 || (_rect2451 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2452 || (_rect2452 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2453 || (_rect2453 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2454 || (_rect2454 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2455 || (_rect2455 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2456 || (_rect2456 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2457 || (_rect2457 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2458 || (_rect2458 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2459 || (_rect2459 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2460 || (_rect2460 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2461 || (_rect2461 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2462 || (_rect2462 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2463 || (_rect2463 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 50,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2464 || (_rect2464 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2465 || (_rect2465 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2466 || (_rect2466 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2467 || (_rect2467 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 50,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2468 || (_rect2468 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 50,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2469 || (_rect2469 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 50,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2470 || (_rect2470 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 51,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2471 || (_rect2471 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 51,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2472 || (_rect2472 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 51,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2473 || (_rect2473 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 51,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2474 || (_rect2474 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 51,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2475 || (_rect2475 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 51,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2476 || (_rect2476 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2477 || (_rect2477 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2478 || (_rect2478 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2479 || (_rect2479 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2480 || (_rect2480 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2481 || (_rect2481 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2482 || (_rect2482 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2483 || (_rect2483 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2484 || (_rect2484 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2485 || (_rect2485 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2486 || (_rect2486 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2487 || (_rect2487 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2488 || (_rect2488 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2489 || (_rect2489 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2490 || (_rect2490 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2491 || (_rect2491 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2492 || (_rect2492 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2493 || (_rect2493 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2494 || (_rect2494 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2495 || (_rect2495 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2496 || (_rect2496 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 51,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2497 || (_rect2497 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2498 || (_rect2498 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2499 || (_rect2499 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2500 || (_rect2500 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 51,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2501 || (_rect2501 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 51,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2502 || (_rect2502 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 51,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2503 || (_rect2503 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 52,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2504 || (_rect2504 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 52,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2505 || (_rect2505 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 52,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2506 || (_rect2506 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 52,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2507 || (_rect2507 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 52,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2508 || (_rect2508 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 52,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2509 || (_rect2509 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2510 || (_rect2510 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2511 || (_rect2511 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2512 || (_rect2512 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2513 || (_rect2513 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2514 || (_rect2514 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2515 || (_rect2515 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2516 || (_rect2516 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2517 || (_rect2517 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2518 || (_rect2518 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2519 || (_rect2519 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2520 || (_rect2520 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2521 || (_rect2521 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2522 || (_rect2522 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2523 || (_rect2523 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2524 || (_rect2524 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2525 || (_rect2525 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2526 || (_rect2526 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2527 || (_rect2527 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 52,
    width: 1,
    height: 1,
    fill: "#FFC95B"
  })), _rect2528 || (_rect2528 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2529 || (_rect2529 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2530 || (_rect2530 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2531 || (_rect2531 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 52,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2532 || (_rect2532 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 52,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2533 || (_rect2533 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 52,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2534 || (_rect2534 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 53,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2535 || (_rect2535 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 53,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2536 || (_rect2536 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 53,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2537 || (_rect2537 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 53,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2538 || (_rect2538 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 53,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2539 || (_rect2539 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 53,
    width: 1,
    height: 1,
    fill: "#E8A94B"
  })), _rect2540 || (_rect2540 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2541 || (_rect2541 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2542 || (_rect2542 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2543 || (_rect2543 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2544 || (_rect2544 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2545 || (_rect2545 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2546 || (_rect2546 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2547 || (_rect2547 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2548 || (_rect2548 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2549 || (_rect2549 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2550 || (_rect2550 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2551 || (_rect2551 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2552 || (_rect2552 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2553 || (_rect2553 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2554 || (_rect2554 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2555 || (_rect2555 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2556 || (_rect2556 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2557 || (_rect2557 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 53,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2558 || (_rect2558 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2559 || (_rect2559 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2560 || (_rect2560 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 53,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2561 || (_rect2561 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 53,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2562 || (_rect2562 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 53,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2563 || (_rect2563 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 54,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2564 || (_rect2564 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 54,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2565 || (_rect2565 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 54,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2566 || (_rect2566 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 54,
    width: 1,
    height: 1,
    fill: "#C18433"
  })), _rect2567 || (_rect2567 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2568 || (_rect2568 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2569 || (_rect2569 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2570 || (_rect2570 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2571 || (_rect2571 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2572 || (_rect2572 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2573 || (_rect2573 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2574 || (_rect2574 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2575 || (_rect2575 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2576 || (_rect2576 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2577 || (_rect2577 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2578 || (_rect2578 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2579 || (_rect2579 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2580 || (_rect2580 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2581 || (_rect2581 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2582 || (_rect2582 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2583 || (_rect2583 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2584 || (_rect2584 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2585 || (_rect2585 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7A4F22"
  })), _rect2586 || (_rect2586 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 54,
    width: 1,
    height: 1,
    fill: "#976420"
  })), _rect2587 || (_rect2587 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 54,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2588 || (_rect2588 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 54,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2589 || (_rect2589 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 54,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2590 || (_rect2590 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2591 || (_rect2591 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2592 || (_rect2592 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2593 || (_rect2593 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2594 || (_rect2594 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2595 || (_rect2595 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2596 || (_rect2596 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2597 || (_rect2597 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2598 || (_rect2598 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2599 || (_rect2599 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2600 || (_rect2600 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2601 || (_rect2601 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2602 || (_rect2602 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2603 || (_rect2603 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2604 || (_rect2604 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2605 || (_rect2605 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2606 || (_rect2606 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2607 || (_rect2607 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2608 || (_rect2608 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2609 || (_rect2609 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2610 || (_rect2610 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2611 || (_rect2611 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2612 || (_rect2612 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2613 || (_rect2613 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2614 || (_rect2614 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 55,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2615 || (_rect2615 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2616 || (_rect2616 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2617 || (_rect2617 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2618 || (_rect2618 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2619 || (_rect2619 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2620 || (_rect2620 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2621 || (_rect2621 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2622 || (_rect2622 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2623 || (_rect2623 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2624 || (_rect2624 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2625 || (_rect2625 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2626 || (_rect2626 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2627 || (_rect2627 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2628 || (_rect2628 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2629 || (_rect2629 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2630 || (_rect2630 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2631 || (_rect2631 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2632 || (_rect2632 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2633 || (_rect2633 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2634 || (_rect2634 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2635 || (_rect2635 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2636 || (_rect2636 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })), _rect2637 || (_rect2637 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 56,
    width: 1,
    height: 1,
    fill: "#491306"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJewel);
export default __webpack_public_path__ + "static/media/jewel.b2df736d6d3f3a30b6af8b5ccb5e5608.svg";
export { ForwardRef as ReactComponent };